var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _g2, _path, _g3, _path2, _path3, _path4, _path5, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path0, _g8, _path1, _path10, _g9, _g0, _g1, _g10, _rect8, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _path11, _g25, _path12, _g26, _g27, _path13, _g28, _path14, _g29, _g30, _path15, _g31, _path16, _path17, _path18, _path19, _path20, _path21, _g32, _g33, _path22, _path23, _g34, _path24, _g35, _g36, _path25, _path26, _path27, _g37, _path28, _g38, _path29, _path30, _path31, _path32, _path33, _g39, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _path48, _path49, _g49, _path50, _g50, _path51, _g51, _path52, _g52, _path53, _g53, _path54, _g54, _path55, _path56, _g55, _g56, _path57, _g57, _g58;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_17245",
    "data-name": "Grupo 17245",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 832.759,
    height: 620.587,
    viewBox: "0 0 832.759 620.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4513",
    "data-name": "Rect\\xE1ngulo 4513",
    width: 832.759,
    height: 620.587,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4439",
    "data-name": "Rect\\xE1ngulo 4439",
    width: 42.721,
    height: 49.605,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4440",
    "data-name": "Rect\\xE1ngulo 4440",
    width: 41.662,
    height: 67.026,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4441",
    "data-name": "Rect\\xE1ngulo 4441",
    width: 28.001,
    height: 39.673,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4442",
    "data-name": "Rect\\xE1ngulo 4442",
    width: 27.599,
    height: 33.066,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4443",
    "data-name": "Rect\\xE1ngulo 4443",
    width: 19.28,
    height: 21.826,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4446",
    "data-name": "Rect\\xE1ngulo 4446",
    width: 32.128,
    height: 207.284,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4447",
    "data-name": "Rect\\xE1ngulo 4447",
    width: 32.111,
    height: 207.284,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4448",
    "data-name": "Rect\\xE1ngulo 4448",
    width: 9.01,
    height: 19.12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4449",
    "data-name": "Rect\\xE1ngulo 4449",
    width: 9.01,
    height: 37.807,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4453",
    "data-name": "Rect\\xE1ngulo 4453",
    width: 230.779,
    height: 23.992,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.93,
    y1: 10.254,
    x2: -1.923,
    y2: 10.254,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c02e57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a10033"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4455",
    "data-name": "Rect\\xE1ngulo 4455",
    width: 230.779,
    height: 23.995,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.93,
    y1: 17.356,
    x2: -1.923,
    y2: 17.356,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4456",
    "data-name": "Rect\\xE1ngulo 4456",
    width: 230.291,
    height: 23.993,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4457",
    "data-name": "Rect\\xE1ngulo 4457",
    width: 230.291,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12542",
    "data-name": "Trazado 12542",
    d: "M309.9,401.334l-23.052-114.8h-8.834l-23.054,114.8L238.021,411.7v3.071h88.272V411.7Z",
    transform: "translate(-238.021 -286.531)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -4.491,
    y1: 1.118,
    x2: -4.472,
    y2: 1.118,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4462",
    "data-name": "Rect\\xE1ngulo 4462",
    width: 88.272,
    height: 3.866,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4463",
    "data-name": "Rect\\xE1ngulo 4463",
    width: 54.942,
    height: 114.464,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4464",
    "data-name": "Rect\\xE1ngulo 4464",
    width: 39.976,
    height: 26.355,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4467",
    "data-name": "Rect\\xE1ngulo 4467",
    width: 100.646,
    height: 77.588,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12547",
    "data-name": "Trazado 12547",
    d: "M128.067,93.053a6.173,6.173,0,1,1,6.2,6.1,5.974,5.974,0,0,1-6.2-6.1m-2.27,0c0,4.652,3.586,8.124,8.466,8.124a8.13,8.13,0,1,0,0-16.249c-4.88,0-8.466,3.473-8.466,8.124",
    transform: "translate(-125.797 -84.929)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -12.408,
    y1: 29.488,
    x2: -12.31,
    y2: 29.488,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12548",
    "data-name": "Trazado 12548",
    d: "M139.36,93.413a4.056,4.056,0,1,1,4.062,4.244,3.965,3.965,0,0,1-4.062-4.244m-2.2,0a6.254,6.254,0,1,0,6.262-6.127,6,6,0,0,0-6.262,6.127",
    transform: "translate(-137.16 -87.286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -18.269,
    y1: 38.704,
    x2: -18.135,
    y2: 38.704,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12549",
    "data-name": "Trazado 12549",
    d: "M148.636,93.413a4.054,4.054,0,1,1,4.037,4.244,3.97,3.97,0,0,1-4.037-4.244m-.07-4.107V87.4h-2.087v16.432h2.177V97.612a5.146,5.146,0,0,0,4.2,1.952,6.139,6.139,0,0,0,0-12.278,5.117,5.117,0,0,0-4.289,2.02",
    transform: "translate(-146.479 -87.286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -19.583,
    y1: 28.722,
    x2: -19.449,
    y2: 28.722,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12550",
    "data-name": "Trazado 12550",
    d: "M155.243,90.9c0,4.787,7.6,2.45,7.6,5.15,0,1.023-.839,1.634-2.86,1.634a7.737,7.737,0,0,1-4.222-1.247l-.906,1.724a8.671,8.671,0,0,0,4.968,1.409c3.2,0,5.2-1.384,5.2-3.564,0-4.675-7.626-2.358-7.626-5.2,0-.953.931-1.657,2.838-1.657a6.269,6.269,0,0,1,3.471.954l.931-1.725a8.742,8.742,0,0,0-4.38-1.089c-3.086,0-5.015,1.452-5.015,3.609",
    transform: "translate(-154.858 -87.286)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -25.37,
    y1: 38.704,
    x2: -25.206,
    y2: 38.704,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12551",
    "data-name": "Trazado 12551",
    d: "M162.3,99.607a1.46,1.46,0,0,0,1.5,1.454,1.434,1.434,0,0,0,1.452-1.454,1.42,1.42,0,0,0-1.452-1.452,1.446,1.446,0,0,0-1.5,1.452m.2-14.57.408,10.872h1.725l.43-10.872Z",
    transform: "translate(-162.296 -85.037)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -91.642,
    y1: 29.89,
    x2: -91.077,
    y2: 29.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4474",
    "data-name": "Rect\\xE1ngulo 4474",
    width: 18.514,
    height: 18.662,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12555",
    "data-name": "Trazado 12555",
    d: "M116.964,357.27a11.956,11.956,0,0,1,4.222-1.7.661.661,0,0,1,.376.078c.077,0,.172.11.188.345a1.205,1.205,0,0,1-.393,1.051,5.99,5.99,0,0,1-4.394.221m-.924-.127a.263.263,0,0,0-.14.281.3.3,0,0,0,.218.252,14.8,14.8,0,0,0,3.231.455,3.692,3.692,0,0,0,2.37-.626,1.73,1.73,0,0,0,.611-1.571.875.875,0,0,0-.5-.814,1.362,1.362,0,0,0-.625-.128c-1.682,0-4.78,1.905-5.165,2.152",
    transform: "translate(-115.895 -354.992)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -29.532,
    y1: 9.145,
    x2: -29.278,
    y2: 9.145,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12556",
    "data-name": "Trazado 12556",
    d: "M118.015,354.053a1.009,1.009,0,0,1,.658-.252h.142c.378,0,.41.222.425.3.157.8-1.412,2.856-2.683,3.814a6.915,6.915,0,0,1,1.459-3.861m-.378-.345c-1.426,1.161-1.724,4.707-1.739,4.88a.313.313,0,0,0,.14.266.276.276,0,0,0,.157-.048h.142c1.271-.69,3.734-3.4,3.483-4.707a.956.956,0,0,0-.941-.768,1.4,1.4,0,0,0-.2-.013,1.575,1.575,0,0,0-1.038.39",
    transform: "translate(-115.898 -353.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -46.248,
    y1: 5.804,
    x2: -45.849,
    y2: 5.804,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4478",
    "data-name": "Rect\\xE1ngulo 4478",
    width: 14.598,
    height: 15.561,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12560",
    "data-name": "Trazado 12560",
    d: "M220.031,357.27a11.928,11.928,0,0,1,4.219-1.7.661.661,0,0,1,.378.078c.078,0,.172.11.187.345a1.207,1.207,0,0,1-.39,1.051,5.99,5.99,0,0,1-4.394.221m-.928-.127a.265.265,0,0,0-.14.281.3.3,0,0,0,.22.252,14.8,14.8,0,0,0,3.233.455,3.688,3.688,0,0,0,2.368-.626,1.73,1.73,0,0,0,.611-1.571.877.877,0,0,0-.5-.814,1.35,1.35,0,0,0-.623-.128c-1.682,0-4.782,1.905-5.166,2.152",
    transform: "translate(-218.96 -354.992)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -55.812,
    y1: 9.145,
    x2: -55.557,
    y2: 9.145,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12561",
    "data-name": "Trazado 12561",
    d: "M221.081,354.053a1.01,1.01,0,0,1,.66-.252h.14c.376,0,.408.222.425.3.155.8-1.412,2.856-2.683,3.814a6.9,6.9,0,0,1,1.459-3.861m-.376-.345c-1.429,1.161-1.725,4.707-1.742,4.88a.317.317,0,0,0,.14.266.278.278,0,0,0,.158-.048h.142c1.271-.69,3.732-3.4,3.483-4.707a.955.955,0,0,0-.941-.768,1.389,1.389,0,0,0-.2-.013,1.571,1.571,0,0,0-1.036.39",
    transform: "translate(-218.962 -353.318)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -87.375,
    y1: 5.804,
    x2: -86.976,
    y2: 5.804,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4482",
    "data-name": "Rect\\xE1ngulo 4482",
    width: 175.964,
    height: 252.643,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4483",
    "data-name": "Rect\\xE1ngulo 4483",
    width: 20.233,
    height: 7.412,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4484",
    "data-name": "Rect\\xE1ngulo 4484",
    width: 6.486,
    height: 32.128,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4485",
    "data-name": "Rect\\xE1ngulo 4485",
    width: 15.306,
    height: 39.639,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4486",
    "data-name": "Rect\\xE1ngulo 4486",
    width: 103.978,
    height: 131.348,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4487",
    "data-name": "Rect\\xE1ngulo 4487",
    width: 18.537,
    height: 59.842,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4488",
    "data-name": "Rect\\xE1ngulo 4488",
    width: 10.711,
    height: 24.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4489",
    "data-name": "Rect\\xE1ngulo 4489",
    width: 16.907,
    height: 25.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4490",
    "data-name": "Rect\\xE1ngulo 4490",
    width: 17.576,
    height: 34.221,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12604",
    "data-name": "Trazado 12604",
    d: "M174.651,137.657s8.391,25.038,13.444,34.481l1.1-1.174s-9.222-26.279-10.649-33.307Z",
    transform: "translate(-174.651 -137.657)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -20.006,
    y1: 11.349,
    x2: -19.891,
    y2: 11.349,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12605",
    "data-name": "Trazado 12605",
    d: "M186.356,167.29v1.867s6.6-5.6,8.626-22.238l-1.922-1.977a49.225,49.225,0,0,1-6.7,22.348",
    transform: "translate(-186.356 -144.942)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -35.983,
    y1: 15.659,
    x2: -35.79,
    y2: 15.659,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12606",
    "data-name": "Trazado 12606",
    d: "M182.207,159.187l2.4,9.187H187.6l2.9-8-1.093-2.333s-2.553,2.06-5.559-1.77Z",
    transform: "translate(-182.207 -156.267)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -36.559,
    y1: 29.762,
    x2: -36.358,
    y2: 29.762,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12607",
    "data-name": "Trazado 12607",
    d: "M186.08,161.822s-4.82,27.837-3.5,46.616-1.482,26.177-1.482,26.177l3.558,5.45,4.515-3.459c.493-4.777-.266-22.758-.989-32.779-1.128-15.649,0-42.664,0-42.664Z",
    transform: "translate(-181.095 -161.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -35.212,
    y1: 4.463,
    x2: -35.017,
    y2: 4.463,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12608",
    "data-name": "Trazado 12608",
    d: "M171.284,140.467l8.3,16.4,5.223-2.83,7.765,12.348,10.528-8.95,3.133,4.049,4.908-7.828-3.887-6.509-5.358,2.73-8.771,12.012-.58-14.8-12.28-11.39Z",
    transform: "translate(-171.284 -135.697)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -7.158,
    y1: 12.859,
    x2: -7.116,
    y2: 12.859,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4497",
    "data-name": "Rect\\xE1ngulo 4497",
    width: 39.852,
    height: 30.687,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4499",
    "data-name": "Rect\\xE1ngulo 4499",
    width: 13.661,
    height: 12.321,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12610",
    "data-name": "Trazado 12610",
    d: "M184.065,159.044l9.607-12.321,4.052,7.42-3.133-4.051Z",
    transform: "translate(-184.065 -146.723)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -22.444,
    y1: 30.533,
    x2: -22.322,
    y2: 30.533,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4501",
    "data-name": "Rect\\xE1ngulo 4501",
    width: 12.988,
    height: 15.919,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12611",
    "data-name": "Trazado 12611",
    d: "M189.255,160.482l-4.39-15.919-8.6,6.4,5.223-2.826Z",
    transform: "translate(-176.266 -144.563)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -22.601,
    y1: 23.859,
    x2: -22.473,
    y2: 23.859,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4502",
    "data-name": "Rect\\xE1ngulo 4502",
    width: 33.79,
    height: 83.342,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-65"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4503",
    "data-name": "Rect\\xE1ngulo 4503",
    width: 24.653,
    height: 82.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4504",
    "data-name": "Rect\\xE1ngulo 4504",
    width: 22.499,
    height: 9.547,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4505",
    "data-name": "Rect\\xE1ngulo 4505",
    width: 11.759,
    height: 59.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4506",
    "data-name": "Rect\\xE1ngulo 4506",
    width: 55.483,
    height: 50.766,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4507",
    "data-name": "Rect\\xE1ngulo 4507",
    width: 59.794,
    height: 39.494,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4508",
    "data-name": "Rect\\xE1ngulo 4508",
    width: 55.483,
    height: 31.377,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4509",
    "data-name": "Rect\\xE1ngulo 4509",
    width: 76.952,
    height: 33.364,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4510",
    "data-name": "Rect\\xE1ngulo 4510",
    width: 10.33,
    height: 15.836,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4511",
    "data-name": "Rect\\xE1ngulo 4511",
    width: 8.409,
    height: 6.221,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4514",
    "data-name": "Rect\\xE1ngulo 4514",
    width: 83.991,
    height: 76.727,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17244",
    "data-name": "Grupo 17244",
    clipPath: "url(#clip-path)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4039",
    "data-name": "Rect\\xE1ngulo 4039",
    width: 832.759,
    height: 0.416,
    transform: "translate(0 545.367)",
    fill: "#ebebeb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4040",
    "data-name": "Rect\\xE1ngulo 4040",
    width: 55.165,
    height: 0.416,
    transform: "translate(694.153 572.175)",
    fill: "#ebebeb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4041",
    "data-name": "Rect\\xE1ngulo 4041",
    width: 14.478,
    height: 0.416,
    transform: "translate(537.174 576.694)",
    fill: "#ebebeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4042",
    "data-name": "Rect\\xE1ngulo 4042",
    width: 31.965,
    height: 0.416,
    transform: "translate(660.521 556.709)",
    fill: "#ebebeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4043",
    "data-name": "Rect\\xE1ngulo 4043",
    width: 71.939,
    height: 0.416,
    transform: "translate(87.371 559.507)",
    fill: "#ebebeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4044",
    "data-name": "Rect\\xE1ngulo 4044",
    width: 10.548,
    height: 0.416,
    transform: "translate(174.14 559.507)",
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4045",
    "data-name": "Rect\\xE1ngulo 4045",
    width: 156.019,
    height: 0.415,
    transform: "translate(218.967 566.541)",
    fill: "#ebebeb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17060",
    "data-name": "Grupo 17060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17059",
    "data-name": "Grupo 17059",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12476",
    "data-name": "Trazado 12476",
    d: "M388.152,424.314h67.472L441.988,180.355h-40.2Z",
    transform: "translate(258.322 120.03)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4046",
    "data-name": "Rect\\xE1ngulo 4046",
    width: 45.848,
    height: 12.598,
    transform: "translate(657.286 294.479)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12477",
    "data-name": "Trazado 12477",
    d: "M339.033,424.314h67.472L392.869,180.355h-40.2Z",
    transform: "translate(225.633 120.03)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4047",
    "data-name": "Rect\\xE1ngulo 4047",
    width: 45.848,
    height: 12.598,
    transform: "translate(575.478 294.479)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4048",
    "data-name": "Rect\\xE1ngulo 4048",
    width: 73.356,
    height: 38.379,
    transform: "translate(581.061 505.966)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4049",
    "data-name": "Rect\\xE1ngulo 4049",
    width: 73.356,
    height: 38.379,
    transform: "translate(500.991 505.966)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4050",
    "data-name": "Rect\\xE1ngulo 4050",
    width: 73.356,
    height: 38.379,
    transform: "translate(663.527 505.966)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12478",
    "data-name": "Trazado 12478",
    d: "M262.828,306.315v-17.17l-42.416,17.17v-17.17L178,306.315v-17.17l-42.416,17.17v-17.17L84.41,309.861h-.516V189.96H57.565V417.921H305.244V289.145Z",
    transform: "translate(38.31 126.422)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4051",
    "data-name": "Rect\\xE1ngulo 4051",
    width: 128.781,
    height: 61.934,
    transform: "translate(250.031 482.409)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12479",
    "data-name": "Trazado 12479",
    d: "M149.852,288.884H128.517A5.6,5.6,0,0,0,123,294.567V337.93a5.641,5.641,0,0,0,4.2,5.5v8.654h3.519v-8.472h6.707v8.472h3.518v-8.472h6.709v8.472h3.518v-8.654a5.64,5.64,0,0,0,4.2-5.5V294.567a5.6,5.6,0,0,0-5.515-5.683",
    transform: "translate(81.861 192.257)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12480",
    "data-name": "Trazado 12480",
    d: "M126.206,288.884H104.871a5.6,5.6,0,0,0-5.513,5.683V337.93a5.641,5.641,0,0,0,4.2,5.5v8.654h3.519v-8.472h6.707v8.472H117.3v-8.472h6.707v8.472h3.518v-8.654a5.64,5.64,0,0,0,4.2-5.5V294.567a5.6,5.6,0,0,0-5.515-5.683",
    transform: "translate(66.124 192.257)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12481",
    "data-name": "Trazado 12481",
    d: "M102.56,288.884H81.225a5.6,5.6,0,0,0-5.513,5.683V337.93a5.641,5.641,0,0,0,4.2,5.5v8.654h3.519v-8.472h6.707v8.472h3.518v-8.472h6.709v8.472h3.518v-8.654a5.642,5.642,0,0,0,4.2-5.5V294.567a5.6,5.6,0,0,0-5.515-5.683",
    transform: "translate(50.388 192.257)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12482",
    "data-name": "Trazado 12482",
    d: "M80.036,157.364c-.32-6.339,13.1-8.974,15.663-3.7s-2.558,9.225-2.558,9.225,7.673,3.164,1.279,8.006-8.949,0-8.949,0-7.352,6.819-9.27,4.184,1.919-4.688,1.919-4.688-6.181.4-5.328-5.854,7.245-7.168,7.245-7.168",
    transform: "translate(48.39 100.39)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12483",
    "data-name": "Trazado 12483",
    d: "M66.9,173.792c-.16-3.169,6.552-4.487,7.831-1.852s-1.279,4.613-1.279,4.613,3.836,1.582.64,4-4.475,0-4.475,0-3.676,3.409-4.635,2.092.959-2.343.959-2.343a2.415,2.415,0,0,1-2.663-2.928,4.35,4.35,0,0,1,3.623-3.584",
    transform: "translate(42.088 113.492)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12484",
    "data-name": "Trazado 12484",
    d: "M68.081,136.6c-.46-9.1,18.812-12.883,22.483-5.316s-3.671,13.243-3.671,13.243,11.012,4.542,1.835,11.492-12.848,0-12.848,0-10.553,9.788-13.306,6,2.753-6.729,2.753-6.729-8.871.581-7.646-8.4,10.4-10.29,10.4-10.29",
    transform: "translate(38.311 84.678)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12485",
    "data-name": "Trazado 12485",
    d: "M366.906,146.543c-.32-6.339,13.1-8.974,15.663-3.7s-2.558,9.225-2.558,9.225,7.673,3.164,1.279,8.006-8.949,0-8.949,0-7.352,6.819-9.27,4.184,1.919-4.688,1.919-4.688-6.181.4-5.328-5.854,7.245-7.168,7.245-7.168",
    transform: "translate(239.307 93.188)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12486",
    "data-name": "Trazado 12486",
    d: "M353.775,162.971c-.16-3.169,6.552-4.487,7.831-1.852s-1.279,4.613-1.279,4.613,3.836,1.582.639,4-4.475,0-4.475,0-3.676,3.409-4.633,2.092.958-2.343.958-2.343a2.415,2.415,0,0,1-2.663-2.928,4.35,4.35,0,0,1,3.623-3.584",
    transform: "translate(233.005 106.29)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12487",
    "data-name": "Trazado 12487",
    d: "M354.951,125.775c-.458-9.1,18.812-12.883,22.483-5.316s-3.671,13.243-3.671,13.243,11.012,4.542,1.835,11.492-12.848,0-12.848,0-10.553,9.788-13.306,6,2.753-6.729,2.753-6.729-8.871.581-7.646-8.4,10.4-10.29,10.4-10.29",
    transform: "translate(229.228 77.477)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12488",
    "data-name": "Trazado 12488",
    d: "M420.389,149.52c-.32-6.339,13.1-8.974,15.662-3.7s-2.558,9.225-2.558,9.225,7.673,3.164,1.279,8.006-8.949,0-8.949,0-7.353,6.819-9.27,4.184,1.917-4.688,1.917-4.688-6.179.4-5.326-5.854,7.245-7.168,7.245-7.168",
    transform: "translate(274.901 95.169)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12489",
    "data-name": "Trazado 12489",
    d: "M407.258,165.949c-.16-3.169,6.552-4.487,7.831-1.852s-1.279,4.613-1.279,4.613,3.836,1.582.639,4-4.475,0-4.475,0-3.676,3.409-4.635,2.092.959-2.343.959-2.343a2.415,2.415,0,0,1-2.663-2.928,4.35,4.35,0,0,1,3.622-3.584",
    transform: "translate(268.599 108.272)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12490",
    "data-name": "Trazado 12490",
    d: "M408.434,128.753c-.46-9.1,18.81-12.883,22.481-5.316s-3.671,13.243-3.671,13.243,11.012,4.542,1.835,11.492-12.848,0-12.848,0-10.553,9.788-13.306,6,2.753-6.729,2.753-6.729-8.869.581-7.646-8.4,10.4-10.29,10.4-10.29",
    transform: "translate(264.821 79.459)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12491",
    "data-name": "Trazado 12491",
    d: "M494.993,368.53V328.423H484.785V188.974H470.029V170.982l-31.507-15.145V137.695h-4.365v51.28h-6.109V328.423h-6.111V255.1H405.352V217.315h-4.628V328.423h-12.6V286.139h-8.293v-10.8h-19.2V238.457H350.115v-26.09H337.187v-38.01h-4.613v38.01H319.646v26.09H309.13v36.886h-19.2v10.8h-8.293v42.284H271.8v-53.08H252.6V161.085h-6.111V148.491H205.458v12.595h-8.727v82.77H161.813v8.1H148.72v6.3h13.093v32.388H140.558v.212h-33.7V452.706H501.977V368.53Z",
    transform: "translate(71.117 91.638)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4052",
    "data-name": "Rect\\xE1ngulo 4052",
    width: 4.947,
    height: 5.098,
    transform: "translate(185.549 390.469)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4053",
    "data-name": "Rect\\xE1ngulo 4053",
    width: 4.947,
    height: 5.098,
    transform: "translate(185.549 399.016)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4054",
    "data-name": "Rect\\xE1ngulo 4054",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 257.169)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4055",
    "data-name": "Rect\\xE1ngulo 4055",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 265.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4056",
    "data-name": "Rect\\xE1ngulo 4056",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 274.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4057",
    "data-name": "Rect\\xE1ngulo 4057",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 282.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4058",
    "data-name": "Rect\\xE1ngulo 4058",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 291.356)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4059",
    "data-name": "Rect\\xE1ngulo 4059",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 299.903)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4060",
    "data-name": "Rect\\xE1ngulo 4060",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 308.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4061",
    "data-name": "Rect\\xE1ngulo 4061",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 316.996)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4062",
    "data-name": "Rect\\xE1ngulo 4062",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 342.637)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4063",
    "data-name": "Rect\\xE1ngulo 4063",
    width: 4.947,
    height: 5.098,
    transform: "translate(274.003 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4064",
    "data-name": "Rect\\xE1ngulo 4064",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 257.169)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4065",
    "data-name": "Rect\\xE1ngulo 4065",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 265.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4066",
    "data-name": "Rect\\xE1ngulo 4066",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 274.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4067",
    "data-name": "Rect\\xE1ngulo 4067",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 282.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4068",
    "data-name": "Rect\\xE1ngulo 4068",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 291.356)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4069",
    "data-name": "Rect\\xE1ngulo 4069",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 299.903)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4070",
    "data-name": "Rect\\xE1ngulo 4070",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 308.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4071",
    "data-name": "Rect\\xE1ngulo 4071",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 316.996)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4072",
    "data-name": "Rect\\xE1ngulo 4072",
    width: 4.947,
    height: 5.098,
    transform: "translate(281.859 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4073",
    "data-name": "Rect\\xE1ngulo 4073",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 257.169)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4074",
    "data-name": "Rect\\xE1ngulo 4074",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 265.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4075",
    "data-name": "Rect\\xE1ngulo 4075",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 274.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4076",
    "data-name": "Rect\\xE1ngulo 4076",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 282.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4077",
    "data-name": "Rect\\xE1ngulo 4077",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 291.356)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4078",
    "data-name": "Rect\\xE1ngulo 4078",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 299.903)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4079",
    "data-name": "Rect\\xE1ngulo 4079",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 308.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4080",
    "data-name": "Rect\\xE1ngulo 4080",
    width: 4.947,
    height: 5.098,
    transform: "translate(289.715 316.996)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4081",
    "data-name": "Rect\\xE1ngulo 4081",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 257.169)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4082",
    "data-name": "Rect\\xE1ngulo 4082",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 265.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4083",
    "data-name": "Rect\\xE1ngulo 4083",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 274.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4084",
    "data-name": "Rect\\xE1ngulo 4084",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 282.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4085",
    "data-name": "Rect\\xE1ngulo 4085",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 291.356)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4086",
    "data-name": "Rect\\xE1ngulo 4086",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 299.903)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4087",
    "data-name": "Rect\\xE1ngulo 4087",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 316.996)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4088",
    "data-name": "Rect\\xE1ngulo 4088",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 325.544)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4089",
    "data-name": "Rect\\xE1ngulo 4089",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4090",
    "data-name": "Rect\\xE1ngulo 4090",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 359.73)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4091",
    "data-name": "Rect\\xE1ngulo 4091",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 368.278)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4092",
    "data-name": "Rect\\xE1ngulo 4092",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 376.825)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4093",
    "data-name": "Rect\\xE1ngulo 4093",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 385.371)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4094",
    "data-name": "Rect\\xE1ngulo 4094",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 393.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4095",
    "data-name": "Rect\\xE1ngulo 4095",
    width: 4.947,
    height: 5.098,
    transform: "translate(297.57 402.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4096",
    "data-name": "Rect\\xE1ngulo 4096",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 257.169)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4097",
    "data-name": "Rect\\xE1ngulo 4097",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 265.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4098",
    "data-name": "Rect\\xE1ngulo 4098",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 274.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4099",
    "data-name": "Rect\\xE1ngulo 4099",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 282.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4100",
    "data-name": "Rect\\xE1ngulo 4100",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 291.356)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4101",
    "data-name": "Rect\\xE1ngulo 4101",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 299.903)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4102",
    "data-name": "Rect\\xE1ngulo 4102",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 325.544)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4103",
    "data-name": "Rect\\xE1ngulo 4103",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 334.09)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4104",
    "data-name": "Rect\\xE1ngulo 4104",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 342.637)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4105",
    "data-name": "Rect\\xE1ngulo 4105",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4106",
    "data-name": "Rect\\xE1ngulo 4106",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 359.73)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4107",
    "data-name": "Rect\\xE1ngulo 4107",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 368.278)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4108",
    "data-name": "Rect\\xE1ngulo 4108",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 376.825)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4109",
    "data-name": "Rect\\xE1ngulo 4109",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 385.371)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4110",
    "data-name": "Rect\\xE1ngulo 4110",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 393.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4111",
    "data-name": "Rect\\xE1ngulo 4111",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 402.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4112",
    "data-name": "Rect\\xE1ngulo 4112",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 411.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4113",
    "data-name": "Rect\\xE1ngulo 4113",
    width: 4.947,
    height: 5.098,
    transform: "translate(305.426 428.106)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4114",
    "data-name": "Rect\\xE1ngulo 4114",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 257.169)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4115",
    "data-name": "Rect\\xE1ngulo 4115",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 265.715)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4116",
    "data-name": "Rect\\xE1ngulo 4116",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 274.262)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4117",
    "data-name": "Rect\\xE1ngulo 4117",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 282.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4118",
    "data-name": "Rect\\xE1ngulo 4118",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 291.356)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4119",
    "data-name": "Rect\\xE1ngulo 4119",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 299.903)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4120",
    "data-name": "Rect\\xE1ngulo 4120",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 325.544)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4121",
    "data-name": "Rect\\xE1ngulo 4121",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 334.09)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4122",
    "data-name": "Rect\\xE1ngulo 4122",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 342.637)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4123",
    "data-name": "Rect\\xE1ngulo 4123",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4124",
    "data-name": "Rect\\xE1ngulo 4124",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 376.825)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4125",
    "data-name": "Rect\\xE1ngulo 4125",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 385.371)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4126",
    "data-name": "Rect\\xE1ngulo 4126",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 393.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4127",
    "data-name": "Rect\\xE1ngulo 4127",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 402.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4128",
    "data-name": "Rect\\xE1ngulo 4128",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 411.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4129",
    "data-name": "Rect\\xE1ngulo 4129",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 428.106)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4130",
    "data-name": "Rect\\xE1ngulo 4130",
    width: 4.947,
    height: 5.098,
    transform: "translate(313.282 436.652)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4131",
    "data-name": "Rect\\xE1ngulo 4131",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4132",
    "data-name": "Rect\\xE1ngulo 4132",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4133",
    "data-name": "Rect\\xE1ngulo 4133",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4134",
    "data-name": "Rect\\xE1ngulo 4134",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4135",
    "data-name": "Rect\\xE1ngulo 4135",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4136",
    "data-name": "Rect\\xE1ngulo 4136",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4137",
    "data-name": "Rect\\xE1ngulo 4137",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4138",
    "data-name": "Rect\\xE1ngulo 4138",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4139",
    "data-name": "Rect\\xE1ngulo 4139",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4140",
    "data-name": "Rect\\xE1ngulo 4140",
    width: 4.947,
    height: 5.098,
    transform: "translate(384.57 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4141",
    "data-name": "Rect\\xE1ngulo 4141",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4142",
    "data-name": "Rect\\xE1ngulo 4142",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4143",
    "data-name": "Rect\\xE1ngulo 4143",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4144",
    "data-name": "Rect\\xE1ngulo 4144",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4145",
    "data-name": "Rect\\xE1ngulo 4145",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4146",
    "data-name": "Rect\\xE1ngulo 4146",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4147",
    "data-name": "Rect\\xE1ngulo 4147",
    width: 4.947,
    height: 5.098,
    transform: "translate(392.426 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4148",
    "data-name": "Rect\\xE1ngulo 4148",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4149",
    "data-name": "Rect\\xE1ngulo 4149",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4150",
    "data-name": "Rect\\xE1ngulo 4150",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4151",
    "data-name": "Rect\\xE1ngulo 4151",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4152",
    "data-name": "Rect\\xE1ngulo 4152",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4153",
    "data-name": "Rect\\xE1ngulo 4153",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4154",
    "data-name": "Rect\\xE1ngulo 4154",
    width: 4.947,
    height: 5.098,
    transform: "translate(400.282 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4155",
    "data-name": "Rect\\xE1ngulo 4155",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4156",
    "data-name": "Rect\\xE1ngulo 4156",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4157",
    "data-name": "Rect\\xE1ngulo 4157",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4158",
    "data-name": "Rect\\xE1ngulo 4158",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4159",
    "data-name": "Rect\\xE1ngulo 4159",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4160",
    "data-name": "Rect\\xE1ngulo 4160",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4161",
    "data-name": "Rect\\xE1ngulo 4161",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4162",
    "data-name": "Rect\\xE1ngulo 4162",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4163",
    "data-name": "Rect\\xE1ngulo 4163",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4164",
    "data-name": "Rect\\xE1ngulo 4164",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4165",
    "data-name": "Rect\\xE1ngulo 4165",
    width: 4.947,
    height: 5.098,
    transform: "translate(408.137 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4166",
    "data-name": "Rect\\xE1ngulo 4166",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4167",
    "data-name": "Rect\\xE1ngulo 4167",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4168",
    "data-name": "Rect\\xE1ngulo 4168",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4169",
    "data-name": "Rect\\xE1ngulo 4169",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4170",
    "data-name": "Rect\\xE1ngulo 4170",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4171",
    "data-name": "Rect\\xE1ngulo 4171",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4172",
    "data-name": "Rect\\xE1ngulo 4172",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4173",
    "data-name": "Rect\\xE1ngulo 4173",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4174",
    "data-name": "Rect\\xE1ngulo 4174",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4175",
    "data-name": "Rect\\xE1ngulo 4175",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4176",
    "data-name": "Rect\\xE1ngulo 4176",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4177",
    "data-name": "Rect\\xE1ngulo 4177",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4178",
    "data-name": "Rect\\xE1ngulo 4178",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 456.295)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4179",
    "data-name": "Rect\\xE1ngulo 4179",
    width: 4.947,
    height: 5.098,
    transform: "translate(415.993 464.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4180",
    "data-name": "Rect\\xE1ngulo 4180",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4181",
    "data-name": "Rect\\xE1ngulo 4181",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4182",
    "data-name": "Rect\\xE1ngulo 4182",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4183",
    "data-name": "Rect\\xE1ngulo 4183",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4184",
    "data-name": "Rect\\xE1ngulo 4184",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4185",
    "data-name": "Rect\\xE1ngulo 4185",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4186",
    "data-name": "Rect\\xE1ngulo 4186",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4187",
    "data-name": "Rect\\xE1ngulo 4187",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4188",
    "data-name": "Rect\\xE1ngulo 4188",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4189",
    "data-name": "Rect\\xE1ngulo 4189",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4190",
    "data-name": "Rect\\xE1ngulo 4190",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 456.295)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4191",
    "data-name": "Rect\\xE1ngulo 4191",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 464.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4192",
    "data-name": "Rect\\xE1ngulo 4192",
    width: 4.947,
    height: 5.098,
    transform: "translate(423.849 473.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4193",
    "data-name": "Rect\\xE1ngulo 4193",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 285.358)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4194",
    "data-name": "Rect\\xE1ngulo 4194",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 293.906)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4195",
    "data-name": "Rect\\xE1ngulo 4195",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 302.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4196",
    "data-name": "Rect\\xE1ngulo 4196",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 310.999)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4197",
    "data-name": "Rect\\xE1ngulo 4197",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 319.546)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4198",
    "data-name": "Rect\\xE1ngulo 4198",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 328.092)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4199",
    "data-name": "Rect\\xE1ngulo 4199",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4200",
    "data-name": "Rect\\xE1ngulo 4200",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4201",
    "data-name": "Rect\\xE1ngulo 4201",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4202",
    "data-name": "Rect\\xE1ngulo 4202",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4203",
    "data-name": "Rect\\xE1ngulo 4203",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4204",
    "data-name": "Rect\\xE1ngulo 4204",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4205",
    "data-name": "Rect\\xE1ngulo 4205",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4206",
    "data-name": "Rect\\xE1ngulo 4206",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4207",
    "data-name": "Rect\\xE1ngulo 4207",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4208",
    "data-name": "Rect\\xE1ngulo 4208",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4209",
    "data-name": "Rect\\xE1ngulo 4209",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4210",
    "data-name": "Rect\\xE1ngulo 4210",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4211",
    "data-name": "Rect\\xE1ngulo 4211",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 439.202)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4212",
    "data-name": "Rect\\xE1ngulo 4212",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 447.748)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4213",
    "data-name": "Rect\\xE1ngulo 4213",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 456.295)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4214",
    "data-name": "Rect\\xE1ngulo 4214",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 464.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4215",
    "data-name": "Rect\\xE1ngulo 4215",
    width: 4.947,
    height: 5.098,
    transform: "translate(506.192 473.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4216",
    "data-name": "Rect\\xE1ngulo 4216",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 285.358)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4217",
    "data-name": "Rect\\xE1ngulo 4217",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 293.906)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4218",
    "data-name": "Rect\\xE1ngulo 4218",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 302.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4219",
    "data-name": "Rect\\xE1ngulo 4219",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 310.999)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4220",
    "data-name": "Rect\\xE1ngulo 4220",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 319.546)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4221",
    "data-name": "Rect\\xE1ngulo 4221",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 328.092)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4222",
    "data-name": "Rect\\xE1ngulo 4222",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4223",
    "data-name": "Rect\\xE1ngulo 4223",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4224",
    "data-name": "Rect\\xE1ngulo 4224",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4225",
    "data-name": "Rect\\xE1ngulo 4225",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4226",
    "data-name": "Rect\\xE1ngulo 4226",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4227",
    "data-name": "Rect\\xE1ngulo 4227",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4228",
    "data-name": "Rect\\xE1ngulo 4228",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4229",
    "data-name": "Rect\\xE1ngulo 4229",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4230",
    "data-name": "Rect\\xE1ngulo 4230",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4231",
    "data-name": "Rect\\xE1ngulo 4231",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4232",
    "data-name": "Rect\\xE1ngulo 4232",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4233",
    "data-name": "Rect\\xE1ngulo 4233",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4234",
    "data-name": "Rect\\xE1ngulo 4234",
    width: 4.947,
    height: 5.098,
    transform: "translate(514.049 439.202)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4235",
    "data-name": "Rect\\xE1ngulo 4235",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 285.358)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4236",
    "data-name": "Rect\\xE1ngulo 4236",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 293.906)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4237",
    "data-name": "Rect\\xE1ngulo 4237",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 302.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4238",
    "data-name": "Rect\\xE1ngulo 4238",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 310.999)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4239",
    "data-name": "Rect\\xE1ngulo 4239",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 319.546)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4240",
    "data-name": "Rect\\xE1ngulo 4240",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 328.092)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4241",
    "data-name": "Rect\\xE1ngulo 4241",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4242",
    "data-name": "Rect\\xE1ngulo 4242",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4243",
    "data-name": "Rect\\xE1ngulo 4243",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4244",
    "data-name": "Rect\\xE1ngulo 4244",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4245",
    "data-name": "Rect\\xE1ngulo 4245",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4246",
    "data-name": "Rect\\xE1ngulo 4246",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4247",
    "data-name": "Rect\\xE1ngulo 4247",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4248",
    "data-name": "Rect\\xE1ngulo 4248",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4249",
    "data-name": "Rect\\xE1ngulo 4249",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4250",
    "data-name": "Rect\\xE1ngulo 4250",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4251",
    "data-name": "Rect\\xE1ngulo 4251",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4252",
    "data-name": "Rect\\xE1ngulo 4252",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4253",
    "data-name": "Rect\\xE1ngulo 4253",
    width: 4.947,
    height: 5.098,
    transform: "translate(521.905 439.202)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4254",
    "data-name": "Rect\\xE1ngulo 4254",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 285.358)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4255",
    "data-name": "Rect\\xE1ngulo 4255",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 293.906)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4256",
    "data-name": "Rect\\xE1ngulo 4256",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 302.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4257",
    "data-name": "Rect\\xE1ngulo 4257",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 310.999)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4258",
    "data-name": "Rect\\xE1ngulo 4258",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 319.546)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4259",
    "data-name": "Rect\\xE1ngulo 4259",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 328.092)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4260",
    "data-name": "Rect\\xE1ngulo 4260",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4261",
    "data-name": "Rect\\xE1ngulo 4261",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4262",
    "data-name": "Rect\\xE1ngulo 4262",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4263",
    "data-name": "Rect\\xE1ngulo 4263",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4264",
    "data-name": "Rect\\xE1ngulo 4264",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4265",
    "data-name": "Rect\\xE1ngulo 4265",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4266",
    "data-name": "Rect\\xE1ngulo 4266",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4267",
    "data-name": "Rect\\xE1ngulo 4267",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4268",
    "data-name": "Rect\\xE1ngulo 4268",
    width: 4.947,
    height: 5.098,
    transform: "translate(529.761 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4269",
    "data-name": "Rect\\xE1ngulo 4269",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 285.358)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4270",
    "data-name": "Rect\\xE1ngulo 4270",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 293.906)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4271",
    "data-name": "Rect\\xE1ngulo 4271",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 302.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4272",
    "data-name": "Rect\\xE1ngulo 4272",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 310.999)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4273",
    "data-name": "Rect\\xE1ngulo 4273",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 319.546)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4274",
    "data-name": "Rect\\xE1ngulo 4274",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 328.092)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4275",
    "data-name": "Rect\\xE1ngulo 4275",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4276",
    "data-name": "Rect\\xE1ngulo 4276",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4277",
    "data-name": "Rect\\xE1ngulo 4277",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4278",
    "data-name": "Rect\\xE1ngulo 4278",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4279",
    "data-name": "Rect\\xE1ngulo 4279",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4280",
    "data-name": "Rect\\xE1ngulo 4280",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4281",
    "data-name": "Rect\\xE1ngulo 4281",
    width: 4.947,
    height: 5.098,
    transform: "translate(537.616 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4282",
    "data-name": "Rect\\xE1ngulo 4282",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 285.358)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4283",
    "data-name": "Rect\\xE1ngulo 4283",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 293.906)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4284",
    "data-name": "Rect\\xE1ngulo 4284",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 302.451)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4285",
    "data-name": "Rect\\xE1ngulo 4285",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 310.999)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4286",
    "data-name": "Rect\\xE1ngulo 4286",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 319.546)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4287",
    "data-name": "Rect\\xE1ngulo 4287",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 328.092)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4288",
    "data-name": "Rect\\xE1ngulo 4288",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 336.639)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4289",
    "data-name": "Rect\\xE1ngulo 4289",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 345.187)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4290",
    "data-name": "Rect\\xE1ngulo 4290",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4291",
    "data-name": "Rect\\xE1ngulo 4291",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4292",
    "data-name": "Rect\\xE1ngulo 4292",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4293",
    "data-name": "Rect\\xE1ngulo 4293",
    width: 4.947,
    height: 5.098,
    transform: "translate(545.472 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4294",
    "data-name": "Rect\\xE1ngulo 4294",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 342.637)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4295",
    "data-name": "Rect\\xE1ngulo 4295",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4296",
    "data-name": "Rect\\xE1ngulo 4296",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 359.73)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4297",
    "data-name": "Rect\\xE1ngulo 4297",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 368.278)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4298",
    "data-name": "Rect\\xE1ngulo 4298",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 376.825)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4299",
    "data-name": "Rect\\xE1ngulo 4299",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 385.371)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4300",
    "data-name": "Rect\\xE1ngulo 4300",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 393.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4301",
    "data-name": "Rect\\xE1ngulo 4301",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 402.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4302",
    "data-name": "Rect\\xE1ngulo 4302",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 411.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4303",
    "data-name": "Rect\\xE1ngulo 4303",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 419.559)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4304",
    "data-name": "Rect\\xE1ngulo 4304",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 428.106)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4305",
    "data-name": "Rect\\xE1ngulo 4305",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 436.652)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4306",
    "data-name": "Rect\\xE1ngulo 4306",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 445.2)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4307",
    "data-name": "Rect\\xE1ngulo 4307",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 462.293)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4308",
    "data-name": "Rect\\xE1ngulo 4308",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 470.84)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4309",
    "data-name": "Rect\\xE1ngulo 4309",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 479.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4310",
    "data-name": "Rect\\xE1ngulo 4310",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 487.933)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4311",
    "data-name": "Rect\\xE1ngulo 4311",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 505.028)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4312",
    "data-name": "Rect\\xE1ngulo 4312",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 513.574)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4313",
    "data-name": "Rect\\xE1ngulo 4313",
    width: 4.947,
    height: 5.098,
    transform: "translate(239.67 522.121)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4314",
    "data-name": "Rect\\xE1ngulo 4314",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 342.637)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4315",
    "data-name": "Rect\\xE1ngulo 4315",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4316",
    "data-name": "Rect\\xE1ngulo 4316",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 359.73)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4317",
    "data-name": "Rect\\xE1ngulo 4317",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 368.278)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4318",
    "data-name": "Rect\\xE1ngulo 4318",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 376.825)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4319",
    "data-name": "Rect\\xE1ngulo 4319",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 385.371)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4320",
    "data-name": "Rect\\xE1ngulo 4320",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 393.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4321",
    "data-name": "Rect\\xE1ngulo 4321",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 402.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4322",
    "data-name": "Rect\\xE1ngulo 4322",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 411.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4323",
    "data-name": "Rect\\xE1ngulo 4323",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 419.559)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4324",
    "data-name": "Rect\\xE1ngulo 4324",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 428.106)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4325",
    "data-name": "Rect\\xE1ngulo 4325",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 436.652)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4326",
    "data-name": "Rect\\xE1ngulo 4326",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 445.2)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4327",
    "data-name": "Rect\\xE1ngulo 4327",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 470.84)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4328",
    "data-name": "Rect\\xE1ngulo 4328",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 479.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4329",
    "data-name": "Rect\\xE1ngulo 4329",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 496.481)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4330",
    "data-name": "Rect\\xE1ngulo 4330",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 505.028)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4331",
    "data-name": "Rect\\xE1ngulo 4331",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 513.574)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4332",
    "data-name": "Rect\\xE1ngulo 4332",
    width: 4.947,
    height: 5.098,
    transform: "translate(247.524 522.121)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4333",
    "data-name": "Rect\\xE1ngulo 4333",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 342.637)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4334",
    "data-name": "Rect\\xE1ngulo 4334",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 351.184)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4335",
    "data-name": "Rect\\xE1ngulo 4335",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 359.73)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4336",
    "data-name": "Rect\\xE1ngulo 4336",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 368.278)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4337",
    "data-name": "Rect\\xE1ngulo 4337",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 376.825)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4338",
    "data-name": "Rect\\xE1ngulo 4338",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 385.371)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4339",
    "data-name": "Rect\\xE1ngulo 4339",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 393.918)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4340",
    "data-name": "Rect\\xE1ngulo 4340",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 402.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4341",
    "data-name": "Rect\\xE1ngulo 4341",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 411.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4342",
    "data-name": "Rect\\xE1ngulo 4342",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 419.559)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4343",
    "data-name": "Rect\\xE1ngulo 4343",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 428.106)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4344",
    "data-name": "Rect\\xE1ngulo 4344",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 436.652)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4345",
    "data-name": "Rect\\xE1ngulo 4345",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 445.2)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4346",
    "data-name": "Rect\\xE1ngulo 4346",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 453.747)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4347",
    "data-name": "Rect\\xE1ngulo 4347",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 470.84)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4348",
    "data-name": "Rect\\xE1ngulo 4348",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 487.933)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4349",
    "data-name": "Rect\\xE1ngulo 4349",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 496.481)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4350",
    "data-name": "Rect\\xE1ngulo 4350",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 505.028)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4351",
    "data-name": "Rect\\xE1ngulo 4351",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 513.574)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4352",
    "data-name": "Rect\\xE1ngulo 4352",
    width: 4.947,
    height: 5.098,
    transform: "translate(255.38 522.121)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4353",
    "data-name": "Rect\\xE1ngulo 4353",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 391.37)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4354",
    "data-name": "Rect\\xE1ngulo 4354",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 399.916)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4355",
    "data-name": "Rect\\xE1ngulo 4355",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 408.463)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4356",
    "data-name": "Rect\\xE1ngulo 4356",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 417.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4357",
    "data-name": "Rect\\xE1ngulo 4357",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 425.556)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4358",
    "data-name": "Rect\\xE1ngulo 4358",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 434.104)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4359",
    "data-name": "Rect\\xE1ngulo 4359",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 459.744)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4360",
    "data-name": "Rect\\xE1ngulo 4360",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 468.29)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4361",
    "data-name": "Rect\\xE1ngulo 4361",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 476.838)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4362",
    "data-name": "Rect\\xE1ngulo 4362",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 485.385)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4363",
    "data-name": "Rect\\xE1ngulo 4363",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 493.933)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4364",
    "data-name": "Rect\\xE1ngulo 4364",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 502.478)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4365",
    "data-name": "Rect\\xE1ngulo 4365",
    width: 4.947,
    height: 5.098,
    transform: "translate(207.663 511.026)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4366",
    "data-name": "Rect\\xE1ngulo 4366",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 391.37)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4367",
    "data-name": "Rect\\xE1ngulo 4367",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 399.916)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4368",
    "data-name": "Rect\\xE1ngulo 4368",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 408.463)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4369",
    "data-name": "Rect\\xE1ngulo 4369",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 417.011)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4370",
    "data-name": "Rect\\xE1ngulo 4370",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 425.556)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4371",
    "data-name": "Rect\\xE1ngulo 4371",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 434.104)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4372",
    "data-name": "Rect\\xE1ngulo 4372",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 459.744)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4373",
    "data-name": "Rect\\xE1ngulo 4373",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 468.29)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4374",
    "data-name": "Rect\\xE1ngulo 4374",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 476.838)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4375",
    "data-name": "Rect\\xE1ngulo 4375",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 485.385)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4376",
    "data-name": "Rect\\xE1ngulo 4376",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 493.933)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4377",
    "data-name": "Rect\\xE1ngulo 4377",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 502.478)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4378",
    "data-name": "Rect\\xE1ngulo 4378",
    width: 4.947,
    height: 5.098,
    transform: "translate(215.518 519.572)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4379",
    "data-name": "Rect\\xE1ngulo 4379",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4380",
    "data-name": "Rect\\xE1ngulo 4380",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4381",
    "data-name": "Rect\\xE1ngulo 4381",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4382",
    "data-name": "Rect\\xE1ngulo 4382",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4383",
    "data-name": "Rect\\xE1ngulo 4383",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4384",
    "data-name": "Rect\\xE1ngulo 4384",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4385",
    "data-name": "Rect\\xE1ngulo 4385",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4386",
    "data-name": "Rect\\xE1ngulo 4386",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4387",
    "data-name": "Rect\\xE1ngulo 4387",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4388",
    "data-name": "Rect\\xE1ngulo 4388",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4389",
    "data-name": "Rect\\xE1ngulo 4389",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 439.202)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4390",
    "data-name": "Rect\\xE1ngulo 4390",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 456.295)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4391",
    "data-name": "Rect\\xE1ngulo 4391",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 464.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4392",
    "data-name": "Rect\\xE1ngulo 4392",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 473.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4393",
    "data-name": "Rect\\xE1ngulo 4393",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 481.936)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4394",
    "data-name": "Rect\\xE1ngulo 4394",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 490.483)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4395",
    "data-name": "Rect\\xE1ngulo 4395",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 499.029)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4396",
    "data-name": "Rect\\xE1ngulo 4396",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 507.576)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4397",
    "data-name": "Rect\\xE1ngulo 4397",
    width: 4.947,
    height: 5.098,
    transform: "translate(476.515 516.124)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4398",
    "data-name": "Rect\\xE1ngulo 4398",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 353.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4399",
    "data-name": "Rect\\xE1ngulo 4399",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 362.28)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4400",
    "data-name": "Rect\\xE1ngulo 4400",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 370.827)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4401",
    "data-name": "Rect\\xE1ngulo 4401",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 379.373)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4402",
    "data-name": "Rect\\xE1ngulo 4402",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 387.921)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4403",
    "data-name": "Rect\\xE1ngulo 4403",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 396.466)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4404",
    "data-name": "Rect\\xE1ngulo 4404",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 405.014)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4405",
    "data-name": "Rect\\xE1ngulo 4405",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 413.561)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4406",
    "data-name": "Rect\\xE1ngulo 4406",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 422.107)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4407",
    "data-name": "Rect\\xE1ngulo 4407",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 430.655)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4408",
    "data-name": "Rect\\xE1ngulo 4408",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 439.202)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4409",
    "data-name": "Rect\\xE1ngulo 4409",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 447.748)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4410",
    "data-name": "Rect\\xE1ngulo 4410",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 456.295)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4411",
    "data-name": "Rect\\xE1ngulo 4411",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 464.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4412",
    "data-name": "Rect\\xE1ngulo 4412",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 473.388)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4413",
    "data-name": "Rect\\xE1ngulo 4413",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 481.936)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4414",
    "data-name": "Rect\\xE1ngulo 4414",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 490.483)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4415",
    "data-name": "Rect\\xE1ngulo 4415",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 499.029)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4416",
    "data-name": "Rect\\xE1ngulo 4416",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 507.576)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4417",
    "data-name": "Rect\\xE1ngulo 4417",
    width: 4.947,
    height: 5.098,
    transform: "translate(484.369 516.124)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4418",
    "data-name": "Rect\\xE1ngulo 4418",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 387.021)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4419",
    "data-name": "Rect\\xE1ngulo 4419",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 395.567)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4420",
    "data-name": "Rect\\xE1ngulo 4420",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 404.115)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4421",
    "data-name": "Rect\\xE1ngulo 4421",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 412.662)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4422",
    "data-name": "Rect\\xE1ngulo 4422",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 421.208)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4423",
    "data-name": "Rect\\xE1ngulo 4423",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 429.755)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4424",
    "data-name": "Rect\\xE1ngulo 4424",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 438.303)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4425",
    "data-name": "Rect\\xE1ngulo 4425",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 446.848)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4426",
    "data-name": "Rect\\xE1ngulo 4426",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 455.396)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4427",
    "data-name": "Rect\\xE1ngulo 4427",
    width: 4.947,
    height: 5.098,
    transform: "translate(437.816 463.943)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4428",
    "data-name": "Rect\\xE1ngulo 4428",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 387.021)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4429",
    "data-name": "Rect\\xE1ngulo 4429",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 395.567)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4430",
    "data-name": "Rect\\xE1ngulo 4430",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 404.115)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4431",
    "data-name": "Rect\\xE1ngulo 4431",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 412.662)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4432",
    "data-name": "Rect\\xE1ngulo 4432",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 421.208)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4433",
    "data-name": "Rect\\xE1ngulo 4433",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 429.755)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4434",
    "data-name": "Rect\\xE1ngulo 4434",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 438.303)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4435",
    "data-name": "Rect\\xE1ngulo 4435",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 446.848)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4436",
    "data-name": "Rect\\xE1ngulo 4436",
    width: 4.947,
    height: 5.098,
    transform: "translate(445.673 455.396)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12492",
    "data-name": "Trazado 12492",
    d: "M124.219,62.074a9.233,9.233,0,0,1,9.09-9.369,8.849,8.849,0,0,1,2.61.4,20.459,20.459,0,0,1-.2-2.876c0-10.957,8.619-19.84,19.25-19.84a18.712,18.712,0,0,1,3.546.341A16.717,16.717,0,0,1,172.877,22.4a17.091,17.091,0,0,1,16.83,17.1c.095,0,.187-.015.28-.015a15.99,15.99,0,0,1,0,31.965H133.041l.012-.013a9.235,9.235,0,0,1-8.834-9.355",
    transform: "translate(82.67 14.904)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12493",
    "data-name": "Trazado 12493",
    d: "M228.1,117.141a9.233,9.233,0,0,1,9.09-9.369,8.848,8.848,0,0,1,2.61.4,20.464,20.464,0,0,1-.2-2.876c0-10.957,8.619-19.84,19.25-19.84a18.712,18.712,0,0,1,3.546.341,16.717,16.717,0,0,1,14.367-8.333,17.091,17.091,0,0,1,16.83,17.1c.095,0,.187-.015.28-.015a15.99,15.99,0,0,1,0,31.965H236.924l.012-.013a9.235,9.235,0,0,1-8.834-9.355",
    transform: "translate(151.806 51.552)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12494",
    "data-name": "Trazado 12494",
    d: "M127.474,167.88a9.233,9.233,0,0,1,9.09-9.369,8.849,8.849,0,0,1,2.61.4,20.468,20.468,0,0,1-.2-2.876c0-10.957,8.619-19.84,19.25-19.84a18.713,18.713,0,0,1,3.546.341,16.72,16.72,0,0,1,14.367-8.333,17.091,17.091,0,0,1,16.83,17.1c.095,0,.187-.013.281-.013a15.989,15.989,0,0,1,0,31.963H136.3l.012-.013a9.235,9.235,0,0,1-8.834-9.355",
    transform: "translate(84.836 85.32)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12495",
    "data-name": "Trazado 12495",
    d: "M383.4,93.074a5.58,5.58,0,0,1,5.495-5.663,5.319,5.319,0,0,1,1.577.24,12.457,12.457,0,0,1-.123-1.739,11.817,11.817,0,0,1,11.635-11.992,11.361,11.361,0,0,1,2.142.207,10.107,10.107,0,0,1,8.684-5.037,10.331,10.331,0,0,1,10.173,10.336c.057,0,.112-.01.168-.01a9.664,9.664,0,0,1,0,19.32H388.737l.007-.008a5.582,5.582,0,0,1-5.34-5.654",
    transform: "translate(255.162 45.981)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12496",
    "data-name": "Trazado 12496",
    d: "M69.183,97.249a5.58,5.58,0,0,1,5.495-5.663,5.319,5.319,0,0,1,1.577.24,12.457,12.457,0,0,1-.123-1.739A11.817,11.817,0,0,1,87.765,78.1a11.366,11.366,0,0,1,2.144.207,10.107,10.107,0,0,1,8.684-5.037A10.331,10.331,0,0,1,108.766,83.6c.057,0,.112-.01.168-.01a9.664,9.664,0,0,1,0,19.32H74.516l.007-.008a5.582,5.582,0,0,1-5.34-5.654",
    transform: "translate(46.043 48.76)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12497",
    "data-name": "Trazado 12497",
    d: "M320.193,56.942a5.58,5.58,0,0,1,5.495-5.661,5.266,5.266,0,0,1,1.577.24,12.457,12.457,0,0,1-.123-1.739,11.819,11.819,0,0,1,11.635-11.993,11.361,11.361,0,0,1,2.142.208A10.107,10.107,0,0,1,349.6,32.96a10.331,10.331,0,0,1,10.173,10.335c.057,0,.112-.008.168-.008a9.664,9.664,0,0,1,0,19.32H325.526l.007-.008a5.581,5.581,0,0,1-5.34-5.656",
    transform: "translate(213.094 21.935)",
    fill: "#f5f5f5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17062",
    "data-name": "Grupo 17062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17061",
    "data-name": "Grupo 17061",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12498",
    "data-name": "Trazado 12498",
    d: "M701.962,368.822c0,10.416-144.579,18.859-322.925,18.859S56.111,379.238,56.111,368.822s144.579-18.859,322.926-18.859,322.925,8.444,322.925,18.859",
    transform: "translate(37.343 232.907)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17082",
    "data-name": "Grupo 17082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17081",
    "data-name": "Grupo 17081",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12499",
    "data-name": "Trazado 12499",
    d: "M95.364,286.556c.35,2.448-6.291,4.061-11.705,4.963.441,4.445,3.4,8.939,7.485,13.134,5.138-2.895,12.475-6.722,13.827-5.788,1.476,1.021-6.037,5.879-10.734,8.734a96.414,96.414,0,0,0,10.641,8.061c2.3-2.152,5-4.041,6.607-3.02,1.666,1.061,1.216,4.39.393,7.362,5.591,3.259,9.777,5.243,9.777,5.243a113.029,113.029,0,0,0,3.734-15.872c-.281-.556-.561-1.119-.819-1.714-.9-2.085-.023-2.971,1.466-3.263a55.574,55.574,0,0,0,.092-11.435c-6.327-1.327-14.022-3.782-11.141-7.578,1.739-2.288,4.92-2.547,8.231-1.974a13.853,13.853,0,0,0-1.562-2.13c-11.515-12.688-19.548,0-19.548,0-6.694-5.576-16.092-4.067-18.124,4.648,3.757-.964,10.951-2.4,11.382.628",
    transform: "translate(55.677 183.443)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17065",
    "data-name": "Grupo 17065",
    transform: "translate(139.337 459.084)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17064",
    "data-name": "Grupo 17064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17063",
    "data-name": "Grupo 17063",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12500",
    "data-name": "Trazado 12500",
    d: "M95.364,286.556c.35,2.448-6.291,4.061-11.705,4.963.441,4.445,3.4,8.939,7.485,13.134,5.138-2.895,12.475-6.722,13.827-5.788,1.476,1.021-6.037,5.879-10.734,8.734a96.414,96.414,0,0,0,10.641,8.061c2.3-2.152,5-4.041,6.607-3.02,1.666,1.061,1.216,4.39.393,7.362,5.591,3.259,9.777,5.243,9.777,5.243a113.029,113.029,0,0,0,3.734-15.872c-.281-.556-.561-1.119-.819-1.714-.9-2.085-.023-2.971,1.466-3.263a55.574,55.574,0,0,0,.092-11.435c-6.327-1.327-14.022-3.782-11.141-7.578,1.739-2.288,4.92-2.547,8.231-1.974a13.853,13.853,0,0,0-1.562-2.13c-11.515-12.688-19.548,0-19.548,0-6.694-5.576-16.092-4.067-18.124,4.648,3.757-.964,10.951-2.4,11.382.628",
    transform: "translate(-83.66 -275.641)",
    fill: "#fff"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12501",
    "data-name": "Trazado 12501",
    d: "M111.917,376.636l-1.661-.137c.07-.858,6.819-85.816-12.25-93.825a6.446,6.446,0,0,0-5.778.145C85.339,286.4,82.038,301.276,82,301.428l-1.627-.355c.14-.643,3.5-15.787,11.081-19.731a8.132,8.132,0,0,1,7.2-.2c20.171,8.473,13.556,91.948,13.264,95.5",
    transform: "translate(53.492 186.611)",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12502",
    "data-name": "Trazado 12502",
    d: "M101.708,379.2c-.338-3.822-8.121-93.715,6.432-103.257,3.489-2.287,6.6-2.776,9.242-1.437,6.877,3.468,7.78,18.171,7.815,18.794l-1.662.093c-.008-.142-.881-14.367-6.9-17.4-2.072-1.041-4.622-.593-7.578,1.346-13.727,9-5.768,100.79-5.686,101.718Z",
    transform: "translate(66.105 182.2)",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12503",
    "data-name": "Trazado 12503",
    d: "M102.165,372.873c-.108-2.926-2.507-71.735,10.744-77.76a9.307,9.307,0,0,1,7.885-.063c9.092,4,14.708,20.949,14.943,21.667l-1.586.518c-.055-.17-5.616-16.96-14.03-20.661a7.6,7.6,0,0,0-6.521.057c-10.161,4.618-10.5,56.558-9.773,76.181Z",
    transform: "translate(67.836 195.798)",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12504",
    "data-name": "Trazado 12504",
    d: "M106.194,373.308l-1.654-.188c2.335-20.479,6.8-75.052-.495-81.56-1.088-.973-2.062-1.273-2.983-.923-4.888,1.875-7.865,19.625-8.6,26.307l-1.656-.182c.281-2.562,2.945-25.1,9.657-27.679,1.536-.59,3.113-.177,4.69,1.234,9.427,8.413,1.386,79.95,1.039,82.991",
    transform: "translate(60.434 192.217)",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12505",
    "data-name": "Trazado 12505",
    d: "M83.358,316.238H143.2l-5,67.027H88.355Z",
    transform: "translate(55.476 210.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17068",
    "data-name": "Grupo 17068",
    transform: "translate(157.009 526.701)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17067",
    "data-name": "Grupo 17067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17066",
    "data-name": "Grupo 17066",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12506",
    "data-name": "Trazado 12506",
    d: "M94.271,316.238l1.666,67.027h35l5-67.027Z",
    transform: "translate(-94.271 -316.238)",
    fill: "#fff"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12507",
    "data-name": "Trazado 12507",
    d: "M92.146,304.187c-.623,1.631-5.271.348-8.921-.951-1.251,2.893-.968,6.677.113,10.666,4.162-.025,10,.13,10.511,1.171.56,1.136-5.738,1.556-9.613,1.705a68.177,68.177,0,0,0,3.8,8.621c2.157-.538,4.469-.779,5.11.4.663,1.224-.756,3.123-2.282,4.675,2.33,3.926,4.232,6.584,4.232,6.584a79.794,79.794,0,0,0,7.745-8.509c.017-.44.037-.883.082-1.337.16-1.594,1-1.84,2.022-1.511a39.045,39.045,0,0,0,3.977-7.02c-3.446-2.988-7.35-7.14-4.272-8.492,1.857-.816,3.907.115,5.753,1.6a9.731,9.731,0,0,0-.233-1.849c-2.751-11.774-12.057-6.7-12.057-6.7-2.215-5.734-8.529-8.026-12.77-3.348,2.648.695,7.575,2.277,6.8,4.29",
    transform: "translate(54.839 197.917)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17071",
    "data-name": "Grupo 17071",
    transform: "translate(137.241 495.305)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17070",
    "data-name": "Grupo 17070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17069",
    "data-name": "Grupo 17069",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12508",
    "data-name": "Trazado 12508",
    d: "M92.146,304.187c-.623,1.631-5.271.348-8.921-.951-1.251,2.893-.968,6.677.113,10.666,4.162-.025,10,.13,10.511,1.171.56,1.136-5.738,1.556-9.613,1.705a68.177,68.177,0,0,0,3.8,8.621c2.157-.538,4.469-.779,5.11.4.663,1.224-.756,3.123-2.282,4.675,2.33,3.926,4.232,6.584,4.232,6.584a79.794,79.794,0,0,0,7.745-8.509c.017-.44.037-.883.082-1.337.16-1.594,1-1.84,2.022-1.511a39.045,39.045,0,0,0,3.977-7.02c-3.446-2.988-7.35-7.14-4.272-8.492,1.857-.816,3.907.115,5.753,1.6a9.731,9.731,0,0,0-.233-1.849c-2.751-11.774-12.057-6.7-12.057-6.7-2.215-5.734-8.529-8.026-12.77-3.348,2.648.695,7.575,2.277,6.8,4.29",
    transform: "translate(-82.401 -297.388)",
    fill: "#fff"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12509",
    "data-name": "Trazado 12509",
    d: "M117.44,312.582a23.066,23.066,0,0,0-5.468,1.151,12.668,12.668,0,0,1-.806-3.959c-.38-12.068,8.259-6.978,12.824-10.526,2.275-1.767,5.065-2.9,7.636-2.393a17.566,17.566,0,0,0-1.033,2.065,1.9,1.9,0,0,0,1.461,2.582,5.478,5.478,0,0,0,3.389-.4,6.188,6.188,0,0,0,.871-.6,16.494,16.494,0,0,1,1.657,4.036,22.941,22.941,0,0,1,.781,5.161,17.512,17.512,0,0,0-2.019.568,1.879,1.879,0,0,0-.755,2.868,8.648,8.648,0,0,0,2.49,1.749,28.082,28.082,0,0,1-1.519,5.656c-.2.033-.411.055-.615.095-.44.085-.873.2-1.3.321a4.813,4.813,0,0,0-.723.265,1.915,1.915,0,0,0-1.129,1.462,1.886,1.886,0,0,0,.711,1.744,7.212,7.212,0,0,0,.9.553,13.277,13.277,0,0,1-4.78,4.822,49.786,49.786,0,0,1-5.083-2.686c.36-.483.721-.966,1.056-1.466a2.825,2.825,0,0,0,.511-1.9,2.579,2.579,0,0,0-.978-1.7,2.562,2.562,0,0,0-3.6.466c-.4.595-.841,1.159-1.277,1.727a31.476,31.476,0,0,1-6.129-5.951l.183-.053a18.971,18.971,0,0,1,3.4-.566,2.565,2.565,0,0,0-.658-5.088",
    transform: "translate(73.975 197.48)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17074",
    "data-name": "Grupo 17074",
    transform: "translate(185.129 494.211)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17073",
    "data-name": "Grupo 17073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17072",
    "data-name": "Grupo 17072",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12510",
    "data-name": "Trazado 12510",
    d: "M117.44,312.582a23.066,23.066,0,0,0-5.468,1.151,12.668,12.668,0,0,1-.806-3.959c-.38-12.068,8.259-6.978,12.824-10.526,2.275-1.767,5.065-2.9,7.636-2.393a17.566,17.566,0,0,0-1.033,2.065,1.9,1.9,0,0,0,1.461,2.582,5.478,5.478,0,0,0,3.389-.4,6.188,6.188,0,0,0,.871-.6,16.494,16.494,0,0,1,1.657,4.036,22.941,22.941,0,0,1,.781,5.161,17.512,17.512,0,0,0-2.019.568,1.879,1.879,0,0,0-.755,2.868,8.648,8.648,0,0,0,2.49,1.749,28.082,28.082,0,0,1-1.519,5.656c-.2.033-.411.055-.615.095-.44.085-.873.2-1.3.321a4.813,4.813,0,0,0-.723.265,1.915,1.915,0,0,0-1.129,1.462,1.886,1.886,0,0,0,.711,1.744,7.212,7.212,0,0,0,.9.553,13.277,13.277,0,0,1-4.78,4.822,49.786,49.786,0,0,1-5.083-2.686c.36-.483.721-.966,1.056-1.466a2.825,2.825,0,0,0,.511-1.9,2.579,2.579,0,0,0-.978-1.7,2.562,2.562,0,0,0-3.6.466c-.4.595-.841,1.159-1.277,1.727a31.476,31.476,0,0,1-6.129-5.951l.183-.053a18.971,18.971,0,0,1,3.4-.566,2.565,2.565,0,0,0-.658-5.088",
    transform: "translate(-111.154 -296.731)",
    fill: "#fff"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12511",
    "data-name": "Trazado 12511",
    d: "M123.082,284.113a15.776,15.776,0,0,1,3.378-1.8,8.712,8.712,0,0,0-1.314-2.433c-5.1-6.505-7.4-.042-11.356.1a6.738,6.738,0,0,0-5.063,2.094,11.987,11.987,0,0,1,1.449.631,1.3,1.3,0,0,1,.365,2,3.738,3.738,0,0,1-1.955,1.277,4.227,4.227,0,0,1-.723.065,11.254,11.254,0,0,0,.9,2.848,15.755,15.755,0,0,0,1.854,3.053,11.9,11.9,0,0,1,1.311-.586,1.286,1.286,0,0,1,1.656,1.176,5.889,5.889,0,0,1-.541,2.01,19.21,19.21,0,0,0,3.281,2.305c.122-.073.24-.152.365-.22.268-.148.545-.278.824-.4a3.154,3.154,0,0,1,.5-.178,1.31,1.31,0,0,1,1.234.273,1.286,1.286,0,0,1,.391,1.227,4.852,4.852,0,0,1-.228.685,9.1,9.1,0,0,0,4.627.436,33.984,33.984,0,0,0,1.492-3.642c-.4-.1-.8-.192-1.2-.306a1.94,1.94,0,0,1-1.1-.771,1.769,1.769,0,0,1-.235-1.324,1.79,1.79,0,0,1,.771-1.1,1.771,1.771,0,0,1,1.324-.233c.471.137.951.24,1.429.346a21.507,21.507,0,0,0,.608-5.816l-.12.053a12.937,12.937,0,0,0-2.035,1.2,1.756,1.756,0,0,1-1.887-2.963",
    transform: "translate(71.785 184.34)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17077",
    "data-name": "Grupo 17077",
    transform: "translate(179.648 461.328)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17076",
    "data-name": "Grupo 17076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17075",
    "data-name": "Grupo 17075",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12512",
    "data-name": "Trazado 12512",
    d: "M123.082,284.113a15.776,15.776,0,0,1,3.378-1.8,8.712,8.712,0,0,0-1.314-2.433c-5.1-6.505-7.4-.042-11.356.1a6.738,6.738,0,0,0-5.063,2.094,11.987,11.987,0,0,1,1.449.631,1.3,1.3,0,0,1,.365,2,3.738,3.738,0,0,1-1.955,1.277,4.227,4.227,0,0,1-.723.065,11.254,11.254,0,0,0,.9,2.848,15.755,15.755,0,0,0,1.854,3.053,11.9,11.9,0,0,1,1.311-.586,1.286,1.286,0,0,1,1.656,1.176,5.889,5.889,0,0,1-.541,2.01,19.21,19.21,0,0,0,3.281,2.305c.122-.073.24-.152.365-.22.268-.148.545-.278.824-.4a3.154,3.154,0,0,1,.5-.178,1.31,1.31,0,0,1,1.234.273,1.286,1.286,0,0,1,.391,1.227,4.852,4.852,0,0,1-.228.685,9.1,9.1,0,0,0,4.627.436,33.984,33.984,0,0,0,1.492-3.642c-.4-.1-.8-.192-1.2-.306a1.94,1.94,0,0,1-1.1-.771,1.769,1.769,0,0,1-.235-1.324,1.79,1.79,0,0,1,.771-1.1,1.771,1.771,0,0,1,1.324-.233c.471.137.951.24,1.429.346a21.507,21.507,0,0,0,.608-5.816l-.12.053a12.937,12.937,0,0,0-2.035,1.2,1.756,1.756,0,0,1-1.887-2.963",
    transform: "translate(-107.863 -276.988)",
    fill: "#fff"
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12513",
    "data-name": "Trazado 12513",
    d: "M100.123,292.881c-.35,2.448,6.291,4.06,11.705,4.963-.443,4.445-3.4,8.939-7.485,13.134-5.138-2.895-12.475-6.722-13.827-5.788-1.476,1.021,6.037,5.879,10.734,8.734a96.4,96.4,0,0,1-10.641,8.061c-2.3-2.152-5-4.04-6.607-3.019-1.667,1.061-1.216,4.39-.393,7.362-5.591,3.259-9.777,5.243-9.777,5.243A113.03,113.03,0,0,1,70.1,315.7c.281-.556.561-1.119.819-1.714.9-2.085.023-2.971-1.466-3.263a55.575,55.575,0,0,1-.092-11.435c6.327-1.327,14.022-3.782,11.141-7.578-1.739-2.288-4.92-2.547-8.231-1.974a13.846,13.846,0,0,1,1.562-2.13c11.515-12.688,19.548,0,19.548,0,6.694-5.576,16.092-4.067,18.124,4.648-3.757-.964-10.951-2.4-11.382.628",
    transform: "translate(45.991 187.653)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17080",
    "data-name": "Grupo 17080",
    transform: "translate(115.098 469.618)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17079",
    "data-name": "Grupo 17079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17078",
    "data-name": "Grupo 17078",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12514",
    "data-name": "Trazado 12514",
    d: "M100.123,292.881c-.35,2.448,6.291,4.06,11.705,4.963-.443,4.445-3.4,8.939-7.485,13.134-5.138-2.895-12.475-6.722-13.827-5.788-1.476,1.021,6.037,5.879,10.734,8.734a96.4,96.4,0,0,1-10.641,8.061c-2.3-2.152-5-4.04-6.607-3.019-1.667,1.061-1.216,4.39-.393,7.362-5.591,3.259-9.777,5.243-9.777,5.243A113.03,113.03,0,0,1,70.1,315.7c.281-.556.561-1.119.819-1.714.9-2.085.023-2.971-1.466-3.263a55.575,55.575,0,0,1-.092-11.435c6.327-1.327,14.022-3.782,11.141-7.578-1.739-2.288-4.92-2.547-8.231-1.974a13.846,13.846,0,0,1,1.562-2.13c11.515-12.688,19.548,0,19.548,0,6.694-5.576,16.092-4.067,18.124,4.648-3.757-.964-10.951-2.4-11.382.628",
    transform: "translate(-69.106 -281.965)",
    fill: "#fff"
  }))))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12515",
    "data-name": "Trazado 12515",
    d: "M297.616,431.272V232.028h-9.01V431.272l-11.554,4.5V439.3h32.118v-3.534Z",
    transform: "translate(184.383 154.419)",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12516",
    "data-name": "Trazado 12516",
    d: "M397.678,431.272V232.028h-9.01V431.272l-11.554,4.5V439.3h32.118v-3.534Z",
    transform: "translate(250.976 154.419)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17096",
    "data-name": "Grupo 17096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17095",
    "data-name": "Grupo 17095",
    clipPath: "url(#clip-path)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17085",
    "data-name": "Grupo 17085",
    transform: "translate(461.427 386.443)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17084",
    "data-name": "Grupo 17084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17083",
    "data-name": "Grupo 17083",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12517",
    "data-name": "Trazado 12517",
    d: "M309.175,435.779v3.531H277.048v-3.531l11.559-4.514V232.026h9.01V431.265Z",
    transform: "translate(-277.047 -232.026)",
    fill: "#fff"
  }))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17088",
    "data-name": "Grupo 17088",
    transform: "translate(628.095 386.443)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17087",
    "data-name": "Grupo 17087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17086",
    "data-name": "Grupo 17086",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12518",
    "data-name": "Trazado 12518",
    d: "M409.229,435.779v3.531H377.117v-3.531l11.542-4.514V232.026h9.01V431.265Z",
    transform: "translate(-377.117 -232.026)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17091",
    "data-name": "Grupo 17091",
    transform: "translate(472.985 386.443)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17090",
    "data-name": "Grupo 17090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17089",
    "data-name": "Grupo 17089",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12519",
    "data-name": "Trazado 12519",
    d: "M283.987,232.026H293v19.12l-9.01-1.016Z",
    transform: "translate(-283.987 -232.026)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17094",
    "data-name": "Grupo 17094",
    transform: "translate(639.637 386.443)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17093",
    "data-name": "Grupo 17093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17092",
    "data-name": "Grupo 17092",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12520",
    "data-name": "Trazado 12520",
    d: "M393.058,232.026v37.807l-9.01-1.016V232.026Z",
    transform: "translate(-384.047 -232.026)"
  }))))))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4451",
    "data-name": "Rect\\xE1ngulo 4451",
    width: 230.291,
    height: 194.416,
    transform: "translate(445.603 204.146)",
    fill: "#263238"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17098",
    "data-name": "Grupo 17098",
    transform: "translate(445.428 374.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17097",
    "data-name": "Grupo 17097",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4452",
    "data-name": "Rect\\xE1ngulo 4452",
    width: 230.779,
    height: 23.992,
    fill: "url(#linear-gradient)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17100",
    "data-name": "Grupo 17100",
    transform: "translate(445.428 204.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17099",
    "data-name": "Grupo 17099",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4454",
    "data-name": "Rect\\xE1ngulo 4454",
    width: 230.779,
    height: 23.995,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17108",
    "data-name": "Grupo 17108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17107",
    "data-name": "Grupo 17107",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17103",
    "data-name": "Grupo 17103",
    transform: "translate(445.669 374.563)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17102",
    "data-name": "Grupo 17102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17101",
    "data-name": "Grupo 17101",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12521",
    "data-name": "Trazado 12521",
    d: "M290.7,224.9l-17.122,23.984h-6v-8.827L278.412,224.9Z",
    transform: "translate(-267.586 -224.89)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12522",
    "data-name": "Trazado 12522",
    d: "M290.341,248.885h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-260.628 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12523",
    "data-name": "Trazado 12523",
    d: "M304.583,248.885h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-251.15 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12524",
    "data-name": "Trazado 12524",
    d: "M318.824,248.885h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-241.672 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12525",
    "data-name": "Trazado 12525",
    d: "M333.066,248.885h-12.3L337.9,224.894h12.3Z",
    transform: "translate(-232.194 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12526",
    "data-name": "Trazado 12526",
    d: "M347.308,248.885h-12.3l17.132-23.992h12.3Z",
    transform: "translate(-222.715 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12527",
    "data-name": "Trazado 12527",
    d: "M361.55,248.885h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-213.237 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12528",
    "data-name": "Trazado 12528",
    d: "M375.791,248.885h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-203.759 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12529",
    "data-name": "Trazado 12529",
    d: "M390.033,248.885h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-194.281 -224.893)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12530",
    "data-name": "Trazado 12530",
    d: "M415.094,224.9v8.827l-10.826,15.156H391.976L409.1,224.9Z",
    transform: "translate(-184.802 -224.89)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17106",
    "data-name": "Grupo 17106",
    transform: "translate(445.669 204.137)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17105",
    "data-name": "Grupo 17105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17104",
    "data-name": "Grupo 17104",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12531",
    "data-name": "Trazado 12531",
    d: "M290.7,122.567l-17.122,24h-6v-8.844l10.826-15.156Z",
    transform: "translate(-267.586 -122.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12532",
    "data-name": "Trazado 12532",
    d: "M290.341,146.561h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-260.628 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12533",
    "data-name": "Trazado 12533",
    d: "M304.583,146.561h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-251.15 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12534",
    "data-name": "Trazado 12534",
    d: "M318.824,146.561h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-241.672 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12535",
    "data-name": "Trazado 12535",
    d: "M333.066,146.561h-12.3L337.9,122.569h12.3Z",
    transform: "translate(-232.194 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12536",
    "data-name": "Trazado 12536",
    d: "M347.308,146.561h-12.3l17.132-23.992h12.3Z",
    transform: "translate(-222.715 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12537",
    "data-name": "Trazado 12537",
    d: "M361.55,146.561h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-213.237 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12538",
    "data-name": "Trazado 12538",
    d: "M375.791,146.561h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-203.759 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12539",
    "data-name": "Trazado 12539",
    d: "M390.033,146.561h-12.3l17.131-23.992h12.3Z",
    transform: "translate(-194.281 -122.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12540",
    "data-name": "Trazado 12540",
    d: "M415.094,122.567v8.844l-10.826,15.156H391.976l17.122-24Z",
    transform: "translate(-184.802 -122.567)",
    fill: "#fff"
  }))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17110",
    "data-name": "Grupo 17110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17109",
    "data-name": "Grupo 17109",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12541",
    "data-name": "Trazado 12541",
    d: "M492.3,365.513c0-4.552-43.68-8.241-97.561-8.241s-97.559,3.689-97.559,8.241,43.68,8.241,97.559,8.241,97.561-3.689,97.561-8.241",
    transform: "translate(197.777 237.771)",
    fill: "#263238"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17112",
    "data-name": "Grupo 17112",
    transform: "translate(396.428 477.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17111",
    "data-name": "Grupo 17111",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4460",
    "data-name": "Rect\\xE1ngulo 4460",
    width: 88.272,
    height: 128.245,
    fill: "url(#linear-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17123",
    "data-name": "Grupo 17123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17122",
    "data-name": "Grupo 17122",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17115",
    "data-name": "Grupo 17115",
    transform: "translate(396.428 602.396)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17114",
    "data-name": "Grupo 17114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17113",
    "data-name": "Grupo 17113",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4461",
    "data-name": "Rect\\xE1ngulo 4461",
    width: 88.272,
    height: 3.866,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17118",
    "data-name": "Grupo 17118",
    transform: "translate(413.093 477.223)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17117",
    "data-name": "Grupo 17117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17116",
    "data-name": "Grupo 17116",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12543",
    "data-name": "Trazado 12543",
    d: "M280.192,286.531H271.36L248.028,401h54.94Z",
    transform: "translate(-248.027 -286.531)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17121",
    "data-name": "Grupo 17121",
    transform: "translate(420.666 528.183)",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17120",
    "data-name": "Grupo 17120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17119",
    "data-name": "Grupo 17119",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12544",
    "data-name": "Trazado 12544",
    d: "M292.551,343.484l-5.245-26.355h-29.36l-5.373,26.355Z",
    transform: "translate(-252.574 -317.129)",
    fill: "#fff"
  }))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17131",
    "data-name": "Grupo 17131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17130",
    "data-name": "Grupo 17130",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17129",
    "data-name": "Grupo 17129",
    transform: "translate(191.301 123.725)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17128",
    "data-name": "Grupo 17128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17127",
    "data-name": "Grupo 17127",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12545",
    "data-name": "Trazado 12545",
    d: "M200.772,74.286H129.593A14.732,14.732,0,0,0,114.86,89.019V114a14.733,14.733,0,0,0,14.733,14.733h47.3l21.62,23.147L186.8,128.728h13.969A14.733,14.733,0,0,0,215.506,114V89.019a14.732,14.732,0,0,0-14.733-14.733",
    transform: "translate(-114.86 -74.286)",
    fill: "#ff88ad"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17126",
    "data-name": "Grupo 17126",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17125",
    "data-name": "Grupo 17125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17124",
    "data-name": "Grupo 17124",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12546",
    "data-name": "Trazado 12546",
    d: "M200.772,74.286H129.593A14.732,14.732,0,0,0,114.86,89.019V114a14.733,14.733,0,0,0,14.733,14.733h47.3l21.62,23.147L186.8,128.728h13.969A14.733,14.733,0,0,0,215.506,114V89.019a14.732,14.732,0,0,0-14.733-14.733",
    transform: "translate(-114.86 -74.286)",
    fill: "#ff88ad"
  })))))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17133",
    "data-name": "Grupo 17133",
    transform: "translate(209.517 141.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17132",
    "data-name": "Grupo 17132",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4469",
    "data-name": "Rect\\xE1ngulo 4469",
    width: 16.885,
    height: 16.249,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17135",
    "data-name": "Grupo 17135",
    transform: "translate(228.442 145.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17134",
    "data-name": "Grupo 17134",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4470",
    "data-name": "Rect\\xE1ngulo 4470",
    width: 12.505,
    height: 12.278,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17137",
    "data-name": "Grupo 17137",
    transform: "translate(243.963 145.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17136",
    "data-name": "Grupo 17136",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4471",
    "data-name": "Rect\\xE1ngulo 4471",
    width: 12.458,
    height: 16.545,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17139",
    "data-name": "Grupo 17139",
    transform: "translate(257.919 145.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17138",
    "data-name": "Grupo 17138",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4472",
    "data-name": "Rect\\xE1ngulo 4472",
    width: 10.166,
    height: 12.278,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-7)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17141",
    "data-name": "Grupo 17141",
    transform: "translate(270.307 141.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17140",
    "data-name": "Grupo 17140",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4473",
    "data-name": "Rect\\xE1ngulo 4473",
    width: 2.95,
    height: 16.024,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12552",
    "data-name": "Trazado 12552",
    d: "M107.22,366.221l10.688,6.154,15.14-24.252-10.7-6.161Z",
    transform: "translate(71.357 227.582)",
    fill: "#ffb573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17146",
    "data-name": "Grupo 17146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17145",
    "data-name": "Grupo 17145",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17144",
    "data-name": "Grupo 17144",
    transform: "translate(185.882 569.559)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17143",
    "data-name": "Grupo 17143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17142",
    "data-name": "Grupo 17142",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12553",
    "data-name": "Trazado 12553",
    d: "M119.419,341.971l10.7,6.161-7.815,12.5-10.7-6.161Z",
    transform: "translate(-111.606 -341.971)"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12554",
    "data-name": "Trazado 12554",
    d: "M122.915,355.577H107.932a1.084,1.084,0,0,0-1.051.848l-2.432,10.982a1.822,1.822,0,0,0,1.8,2.2c4.848-.08,8.378-.378,14.465-.378,3.751,0,15.061.393,20.239.393s5.851-5.115,3.734-5.584c-9.508-2.072-16.662-4.943-19.706-7.673a2.979,2.979,0,0,0-2.07-.784",
    transform: "translate(69.486 236.643)",
    fill: "#263238"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17148",
    "data-name": "Grupo 17148",
    transform: "translate(193.026 591.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17147",
    "data-name": "Grupo 17147",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4476",
    "data-name": "Rect\\xE1ngulo 4476",
    width: 6.535,
    height: 3.208,
    transform: "translate(-0.017)",
    fill: "url(#linear-gradient-9)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17150",
    "data-name": "Grupo 17150",
    transform: "translate(193.03 588.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17149",
    "data-name": "Grupo 17149",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4477",
    "data-name": "Rect\\xE1ngulo 4477",
    width: 4.174,
    height: 5.536,
    transform: "translate(-0.002)",
    fill: "url(#linear-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17155",
    "data-name": "Grupo 17155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17154",
    "data-name": "Grupo 17154",
    clipPath: "url(#clip-path)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12557",
    "data-name": "Trazado 12557",
    d: "M212.26,369.749l12.713-1.474L221.3,340.967l-12.713,1.474Z",
    transform: "translate(138.816 226.92)",
    fill: "#ffb573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17153",
    "data-name": "Grupo 17153",
    transform: "translate(347.4 567.887)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17152",
    "data-name": "Grupo 17152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17151",
    "data-name": "Grupo 17151",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12558",
    "data-name": "Trazado 12558",
    d: "M208.584,342.441l12.713-1.474,1.887,14.089-12.715,1.472Z",
    transform: "translate(-208.584 -340.967)"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12559",
    "data-name": "Trazado 12559",
    d: "M225.98,355.577H211a1.084,1.084,0,0,0-1.051.848l-2.432,10.982a1.822,1.822,0,0,0,1.8,2.2c4.848-.08,8.378-.378,14.465-.378,3.751,0,15.061.393,20.239.393s5.851-5.115,3.734-5.584c-9.508-2.072-16.662-4.943-19.706-7.673a2.979,2.979,0,0,0-2.07-.784",
    transform: "translate(138.078 236.643)",
    fill: "#263238"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17157",
    "data-name": "Grupo 17157",
    transform: "translate(364.681 591.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17156",
    "data-name": "Grupo 17156",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4480",
    "data-name": "Rect\\xE1ngulo 4480",
    width: 6.534,
    height: 3.208,
    transform: "translate(-0.016)",
    fill: "url(#linear-gradient-11)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17159",
    "data-name": "Grupo 17159",
    transform: "translate(364.685 588.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17158",
    "data-name": "Grupo 17158",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4481",
    "data-name": "Rect\\xE1ngulo 4481",
    width: 4.174,
    height: 5.536,
    transform: "translate(-0.002)",
    fill: "url(#linear-gradient-12)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17188",
    "data-name": "Grupo 17188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17187",
    "data-name": "Grupo 17187",
    clipPath: "url(#clip-path)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12562",
    "data-name": "Trazado 12562",
    d: "M288.634,445.168l-21.354-5.1s-15.471-112.056-51.864-162.838a75.657,75.657,0,0,0-15.306-16.355c-2.265,28.147-4.928,58.093-7.243,74.032C187.171,374.134,131.99,449.7,131.99,449.7l-19.318-8.111s44.351-82.11,46.483-120.667c2.333-41.854,3.348-115.27,3.431-123.865h65.472c6.214,33.993,53.013,111.706,60.577,248.112",
    transform: "translate(74.985 131.144)",
    fill: "#263238"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17162",
    "data-name": "Grupo 17162",
    transform: "translate(187.656 328.2)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17161",
    "data-name": "Grupo 17161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17160",
    "data-name": "Grupo 17160",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12563",
    "data-name": "Trazado 12563",
    d: "M288.634,445.168l-21.354-5.1s-15.471-112.056-51.864-162.838a75.657,75.657,0,0,0-15.306-16.355c-2.265,28.147-4.928,58.093-7.243,74.032C187.171,374.134,131.99,449.7,131.99,449.7l-19.318-8.111s44.351-82.11,46.483-120.667c2.333-41.854,3.348-115.27,3.431-123.865h65.472c6.214,33.993,53.013,111.706,60.577,248.112",
    transform: "translate(-112.67 -197.056)",
    fill: "#fff"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12564",
    "data-name": "Trazado 12564",
    d: "M212.881,153.813c.012,5.02-.128,10.038-.2,15.056-.11,5.018-.236,10.035-.423,15.051-.326,10.035-.786,20.066-1.309,30.1l-.142-1.649c.713,4.487,1.354,8.985,2.005,13.484s1.232,9.009,1.834,13.516c.566,4.514,1.118,9.03,1.612,13.559.451,4.535.958,9.06,1.3,13.617l-8.6,1.654c-1.371-4.359-2.58-8.749-3.842-13.129-1.221-4.387-2.385-8.787-3.534-13.189-1.114-4.407-2.258-8.811-3.311-13.231s-2.139-8.834-3.139-13.264l-.125-.55-.018-1.1c-.165-10.041-.27-20.083-.24-30.123-.008-5.02.043-10.04.112-15.058.11-5.018.147-10.036.338-15.053Z",
    transform: "translate(129.609 102.157)",
    fill: "#ffb573"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12565",
    "data-name": "Trazado 12565",
    d: "M212.621,150.548c5.371,3.348-.889,38.468.41,64.844a57.913,57.913,0,0,0,1.249,7.848l-18.106,2.035s-2.243-8.569-2.55-12.8c-.893-12.3-.012-47.053-.012-47.053Z",
    transform: "translate(128.594 100.192)",
    fill: "#407bff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12566",
    "data-name": "Trazado 12566",
    d: "M213.038,215.387a57.774,57.774,0,0,0,1.249,7.861l-18.121,2.032s-2.232-8.577-2.548-12.808c-.233-3.164-.35-7.828-.383-12.991-.05-7.795.05-16.755.167-23.517-.017-.017,0-.017,0-.017.1-6.179.217-10.526.217-10.526l19-14.873c5.363,3.348-.883,38.473.416,64.839",
    transform: "translate(128.593 100.192)",
    fill: "#ff88ad"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12567",
    "data-name": "Trazado 12567",
    d: "M213.372,220.144l3.453,16.922-15.086.616s-4.076-11.489,3.536-18.059Z",
    transform: "translate(133.535 146.163)",
    fill: "#ffb573"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12568",
    "data-name": "Trazado 12568",
    d: "M212.905,241.884l-11.355-2.232-.246-8.94,15.086-.616Z",
    transform: "translate(133.971 153.133)",
    fill: "#ffb573"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12569",
    "data-name": "Trazado 12569",
    d: "M194.051,194.852l19.678-3.129.555,5.436-18.915,1.975Z",
    transform: "translate(129.145 127.595)",
    fill: "#407bff"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17165",
    "data-name": "Grupo 17165",
    transform: "translate(323.195 319.318)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17164",
    "data-name": "Grupo 17164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17163",
    "data-name": "Grupo 17163",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12570",
    "data-name": "Trazado 12570",
    d: "M194.051,194.852l19.678-3.129.555,5.436-18.915,1.975Z",
    transform: "translate(-194.051 -191.723)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17168",
    "data-name": "Grupo 17168",
    transform: "translate(321.815 267.545)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17167",
    "data-name": "Grupo 17167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17166",
    "data-name": "Grupo 17166",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12571",
    "data-name": "Trazado 12571",
    d: "M193.235,192.766c-.05-7.795.05-16.755.167-23.517-.017-.017,0-.017,0-.017,2.015-4.014,4.014-7.2,5.646-8.594,0,0,3.548,16.539-5.813,32.128",
    transform: "translate(-193.222 -160.638)"
  }))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12572",
    "data-name": "Trazado 12572",
    d: "M230.941,352.947l-27.428-4.081.838-7.6,28.534,3.746Z",
    transform: "translate(135.442 227.121)",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12573",
    "data-name": "Trazado 12573",
    d: "M135.092,358.489l-24.728-9.827,2.938-7.391,25.852,9.717Z",
    transform: "translate(73.449 227.122)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17171",
    "data-name": "Grupo 17171",
    transform: "translate(275.095 368.739)",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17170",
    "data-name": "Grupo 17170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17169",
    "data-name": "Grupo 17169",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12574",
    "data-name": "Trazado 12574",
    d: "M180.477,261.035a75.659,75.659,0,0,0-15.306-16.355l1.815-23.284s11.342,18.587,13.491,39.639",
    transform: "translate(-165.171 -221.396)"
  }))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12575",
    "data-name": "Trazado 12575",
    d: "M246.418,158.343c-24.683,40.955-35.642,91.137-35.642,91.137l-12.058,20.7L190.324,246.8q-1-.15-2.049-.3-1.474-.225-3-.45c-1-.15-2.032-.3-3.065-.466-2.065-.316-4.18-.65-6.3-1-1.049-.167-2.115-.35-3.181-.533-1.066-.167-2.115-.35-3.181-.55-1.049-.183-2.1-.366-3.148-.566-1.049-.183-2.082-.383-3.114-.583-2.848-.55-5.629-1.116-8.244-1.7-.483-.117-.933-.217-1.4-.316-1.932-.45-3.781-.9-5.5-1.366-1.7-.466-3.264-.933-4.68-1.4-.35-.117-.7-.233-1.033-.35a258.252,258.252,0,0,1,11.858-48.95c.833-2.382,1.682-4.663,2.548-6.879a195.709,195.709,0,0,1,11.326-24.233c.083-.167.183-.316.267-.483,7.661-13.724,23.184-19.7,32.511-17.338,7.078,1.815,18.271,6.062,25.949,9.194a170.583,170.583,0,0,1,19.52,9.81",
    transform: "translate(94.796 92.397)",
    fill: "#ff88ad"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17174",
    "data-name": "Grupo 17174",
    transform: "translate(237.236 231.232)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17173",
    "data-name": "Grupo 17173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17172",
    "data-name": "Grupo 17172",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12576",
    "data-name": "Trazado 12576",
    d: "M246.418,158.343c-24.683,40.955-35.642,91.137-35.642,91.137l-12.058,20.7L190.324,246.8q-1-.15-2.049-.3-1.474-.225-3-.45c-1-.15-2.032-.3-3.065-.466-2.065-.316-4.18-.65-6.3-1-1.049-.167-2.115-.35-3.181-.533-1.066-.167-2.115-.35-3.181-.55-1.049-.183-2.1-.366-3.148-.566-1.049-.183-2.082-.383-3.114-.583-2.848-.55-5.629-1.116-8.244-1.7-.483-.117-.933-.217-1.4-.316-1.932-.45-3.781-.9-5.5-1.366-1.7-.45-3.264-.916-4.68-1.4-.35-.117-.7-.233-1.033-.35a258.252,258.252,0,0,1,11.858-48.95c.833-2.382,1.682-4.663,2.548-6.879a195.709,195.709,0,0,1,11.326-24.233c.083-.167.183-.316.267-.483,7.661-13.724,23.184-19.7,32.511-17.338,7.078,1.815,18.271,6.062,25.949,9.194a170.583,170.583,0,0,1,19.52,9.81",
    transform: "translate(-142.44 -138.835)",
    fill: "#ff88ad"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17177",
    "data-name": "Grupo 17177",
    transform: "translate(283.071 279.354)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17176",
    "data-name": "Grupo 17176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17175",
    "data-name": "Grupo 17175",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12577",
    "data-name": "Trazado 12577",
    d: "M188.5,167.728s-.7,3.731-1.549,8.994a88.063,88.063,0,0,1-5.08,16.988c-1.332,2.715-6.812,13.541-5.763,18.371s-4.1,15.489-4.1,15.489q-1-.15-2.049-.3c1.266-5.913,5.513-25.049,7.811-27.265,2.715-2.632,6.945-14.273,6.062-18.654-.866-4.38,4.663-13.624,4.663-13.624",
    transform: "translate(-169.96 -167.728)",
    fill: "#ff88ad"
  }))))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12578",
    "data-name": "Trazado 12578",
    d: "M175.348,220.144l3.453,16.922-15.086.616s-4.076-11.489,3.536-18.059Z",
    transform: "translate(108.23 146.163)",
    fill: "#ffb573"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12579",
    "data-name": "Trazado 12579",
    d: "M174.881,241.884l-11.354-2.232-.248-8.94,15.086-.616Z",
    transform: "translate(108.665 153.133)",
    fill: "#ffb573"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12580",
    "data-name": "Trazado 12580",
    d: "M175.986,149.83c1.732,4.713,14.99,21.585,14.99,21.585l11.742-13.241a9.164,9.164,0,0,1-2.132-2.7,6.48,6.48,0,0,1,.466-6.879,11.158,11.158,0,0,1,2.132-2.115,3.19,3.19,0,0,0,.366-.3l-5.863-21.868c-3.664,8.444-13.074,24.133-21.7,25.516",
    transform: "translate(117.122 82.733)",
    fill: "#ffb573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17180",
    "data-name": "Grupo 17180",
    transform: "translate(309.595 213.959)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17179",
    "data-name": "Grupo 17179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17178",
    "data-name": "Grupo 17178",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12581",
    "data-name": "Trazado 12581",
    d: "M194,152.714a6.48,6.48,0,0,1,.466-6.879,11.158,11.158,0,0,1,2.132-2.115l-8.711-15.256c-5.48,12.142,1.549,20.6,6.112,24.25",
    transform: "translate(-185.885 -128.464)"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12582",
    "data-name": "Trazado 12582",
    d: "M209.867,113.258s4.737,16.527-3.374,24.163-12.158-23.742-12.158-23.742Z",
    transform: "translate(129.333 75.375)",
    fill: "#ffb573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17183",
    "data-name": "Grupo 17183",
    transform: "translate(323.667 188.633)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17182",
    "data-name": "Grupo 17182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17181",
    "data-name": "Grupo 17181",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12583",
    "data-name": "Trazado 12583",
    d: "M209.867,113.258s4.737,16.527-3.374,24.163-12.158-23.742-12.158-23.742Z",
    transform: "translate(-194.334 -113.258)"
  }))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12584",
    "data-name": "Trazado 12584",
    d: "M189.356,154.511a15.424,15.424,0,0,0,18.331,3.662,17.181,17.181,0,0,0,8.7-9.174,17.466,17.466,0,0,0,.6-1.722c3.076-10.869,1.446-36.488-9.612-34.416-9.055,1.7-18.3-.235-22.171,8.143a16.61,16.61,0,0,0-1.549,7.618c.217,12.217-.233,19.408,5.7,25.889",
    transform: "translate(122.222 75.032)",
    fill: "#ffb573"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12585",
    "data-name": "Trazado 12585",
    d: "M199.451,125.263a35.452,35.452,0,0,0,4.4,8.7,5.761,5.761,0,0,1-4.813.7Z",
    transform: "translate(132.463 83.365)",
    fill: "#ed893e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12586",
    "data-name": "Trazado 12586",
    d: "M198.916,120.036a.608.608,0,0,0-.581.185,4.71,4.71,0,0,1-3.876,1.667.581.581,0,1,0-.172,1.149h0A5.788,5.788,0,0,0,199.2,121a.578.578,0,0,0-.027-.819l-.01-.01a.875.875,0,0,0-.25-.132",
    transform: "translate(128.971 79.876)",
    fill: "#263238"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12587",
    "data-name": "Trazado 12587",
    d: "M201.536,119.624a.567.567,0,0,0-.345.017.58.58,0,0,0-.187.8l.007.01a5.782,5.782,0,0,0,4.564,2.761.578.578,0,0,0,.585-.576.6.6,0,0,0-.578-.586A4.7,4.7,0,0,1,202,119.805a.6.6,0,0,0-.465-.182",
    transform: "translate(133.714 79.599)",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12588",
    "data-name": "Trazado 12588",
    d: "M188.881,136.7c-1.169.338-1.241,5.549-.03,10.288l-2.077.585a33.389,33.389,0,0,1-4.995-10.839c-2.618-9.9-2.98-16.31-2.034-21.265l16.407-2.115.693,5.38a4.015,4.015,0,0,0-1.982,5.068c1.769,4.519-.753,11.56-4.209,14.385,0,0-.122-1.962-1.774-1.486",
    transform: "translate(119.308 75.44)",
    fill: "#ffb573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17186",
    "data-name": "Grupo 17186",
    transform: "translate(298.577 188.793)",
    opacity: 0.4,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17185",
    "data-name": "Grupo 17185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17184",
    "data-name": "Grupo 17184",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12589",
    "data-name": "Trazado 12589",
    d: "M188.881,136.7c-1.169.338-1.241,5.549-.03,10.288l-2.077.585a33.389,33.389,0,0,1-4.995-10.839c-2.618-9.9-2.98-16.31-2.034-21.265l16.407-2.115.693,5.38a4.015,4.015,0,0,0-1.982,5.068c1.769,4.519-.753,11.56-4.209,14.385,0,0-.122-1.962-1.774-1.486",
    transform: "translate(-179.27 -113.353)"
  }))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12590",
    "data-name": "Trazado 12590",
    d: "M180.413,131.192a11.625,11.625,0,0,0,6.417,6.144c3.807,1.454,6.086-1.865,5.35-5.659-.685-3.366-3.468-8.288-7.45-8.078s-5.8,4.115-4.317,7.593",
    transform: "translate(119.727 82.253)",
    fill: "#ffb573"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12591",
    "data-name": "Trazado 12591",
    d: "M184.53,116.348s-1.982-3.434,2.348-7.5,22.486-5.758,27.924-2.383,9.868.874,9.59-1.329a4.077,4.077,0,0,1,.3,4.708s3.484-.183,5.183,5.043a4.351,4.351,0,0,0-3.594,1.011,5.488,5.488,0,0,1,1.427,5.075s-1.922-1.969-3.974-1.962a11.579,11.579,0,0,0,2.022,3.538s-7.2.8-10.927-1.927a10.537,10.537,0,0,0,2.87,3.168s-11.732,2.16-15.553-2.468A6.967,6.967,0,0,0,200.983,127s-3.6.1-5.27-2.167c0,0-4.56,3.917-9.9,4.154a12.584,12.584,0,0,0,1.627-2.283s-5.984,3.509-9.915.851a7.536,7.536,0,0,0,1-2.791l-1.561.783s-.108-8.867,7.565-9.2",
    transform: "translate(117.773 69.652)",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12592",
    "data-name": "Trazado 12592",
    d: "M194.918,129.049a7.9,7.9,0,0,1-1.126.227.293.293,0,0,1-.325-.253.3.3,0,0,1,.252-.326c3.741-.47,4.249-3.121,4.267-3.234a.291.291,0,0,1,.575.1,4.824,4.824,0,0,1-3.642,3.491",
    transform: "translate(128.754 83.336)",
    fill: "#ed893e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12593",
    "data-name": "Trazado 12593",
    d: "M204.31,128.878a.288.288,0,0,1-.113.008c-2.1-.253-3.048-3.061-3.088-3.179a.292.292,0,0,1,.187-.368.3.3,0,0,1,.368.185c.008.025.871,2.575,2.6,2.785a.291.291,0,0,1,.043.57",
    transform: "translate(133.832 83.406)",
    fill: "#ed893e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12594",
    "data-name": "Trazado 12594",
    d: "M194.7,125.483c-.11.983.445,1.817,1.106,1.844s1.206-.766,1.252-1.755-.461-1.819-1.106-1.844-1.2.749-1.252,1.755",
    transform: "translate(129.567 82.342)",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12595",
    "data-name": "Trazado 12595",
    d: "M201.446,125.759c-.11.983.461,1.819,1.106,1.844s1.206-.766,1.252-1.755-.461-1.819-1.106-1.844-1.211.813-1.252,1.755",
    transform: "translate(134.057 82.526)",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12596",
    "data-name": "Trazado 12596",
    d: "M194.145,125.844s2.885.07,4.089-.823-1-1.77-2.1-1.77-2.726,1.727-1.992,2.593",
    transform: "translate(129.085 82.026)",
    fill: "#ffb573"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12597",
    "data-name": "Trazado 12597",
    d: "M201.13,125.442s2.711.984,4.137.521-.388-2-1.424-2.347-3.135.771-2.713,1.825",
    transform: "translate(133.819 82.226)",
    fill: "#ffb573"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12598",
    "data-name": "Trazado 12598",
    d: "M204.294,136.823s-1.466.6-3.348,1.216c-3.381,1.116-8.144,2.282-8.428.25a2,2,0,0,1,.416-1.566c1.432-1.965,6.212-2.681,9.377-3.015a5.252,5.252,0,0,0,.45,1.566,4.15,4.15,0,0,0,1.532,1.549",
    transform: "translate(128.11 88.985)",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12599",
    "data-name": "Trazado 12599",
    d: "M200.947,136.869c-3.381,1.116-8.144,2.282-8.428.25a2,2,0,0,1,.416-1.566c2.831-.2,6.679-.167,8.011,1.316",
    transform: "translate(128.11 90.155)",
    fill: "#a02724"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12600",
    "data-name": "Trazado 12600",
    d: "M190.649,123.25s1.729,4.394,0,4.394,0-4.394,0-4.394",
    transform: "translate(126.369 82.025)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12601",
    "data-name": "Trazado 12601",
    d: "M188.946,125.525s1.729,4.394,0,4.394,0-4.394,0-4.394",
    transform: "translate(125.236 83.539)",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12602",
    "data-name": "Trazado 12602",
    d: "M202.262,117s2.655,3.906.968,4.285-.968-4.285-.968-4.285",
    transform: "translate(134.507 77.864)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12603",
    "data-name": "Trazado 12603",
    d: "M203.615,129.732s1.521,4.47-.206,4.389.206-4.389.206-4.389",
    transform: "translate(134.894 86.339)",
    fill: "#fff"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17190",
    "data-name": "Grupo 17190",
    transform: "translate(290.884 229.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17189",
    "data-name": "Grupo 17189",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4492",
    "data-name": "Rect\\xE1ngulo 4492",
    width: 14.54,
    height: 34.481,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-13)"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17192",
    "data-name": "Grupo 17192",
    transform: "translate(310.379 241.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17191",
    "data-name": "Grupo 17191",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4493",
    "data-name": "Rect\\xE1ngulo 4493",
    width: 8.626,
    height: 24.215,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-14)"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17194",
    "data-name": "Grupo 17194",
    transform: "translate(303.469 260.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17193",
    "data-name": "Grupo 17193",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4494",
    "data-name": "Rect\\xE1ngulo 4494",
    width: 8.301,
    height: 12.107,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-15)"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17196",
    "data-name": "Grupo 17196",
    transform: "translate(301.617 268.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17195",
    "data-name": "Grupo 17195",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4495",
    "data-name": "Rect\\xE1ngulo 4495",
    width: 8.566,
    height: 78.902,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-16)"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17198",
    "data-name": "Grupo 17198",
    transform: "translate(285.276 226.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17197",
    "data-name": "Grupo 17197",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4496",
    "data-name": "Rect\\xE1ngulo 4496",
    width: 39.854,
    height: 30.685,
    transform: "translate(0)",
    fill: "url(#linear-gradient-17)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17243",
    "data-name": "Grupo 17243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17242",
    "data-name": "Grupo 17242",
    clipPath: "url(#clip-path)"
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17201",
    "data-name": "Grupo 17201",
    transform: "translate(285.278 226.004)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17200",
    "data-name": "Grupo 17200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17199",
    "data-name": "Grupo 17199",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12609",
    "data-name": "Trazado 12609",
    d: "M171.285,140.468l8.979-4.772,12.28,11.392.58,14.8,8.771-12.012,5.356-2.73,3.887,6.509-4.908,7.828-3.133-4.051-10.526,8.952-7.765-12.346-5.223,2.826Z",
    transform: "translate(-171.285 -135.696)",
    fill: "#e2135d"
  }))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17206",
    "data-name": "Grupo 17206",
    transform: "translate(306.562 244.37)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17205",
    "data-name": "Grupo 17205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17204",
    "data-name": "Grupo 17204",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17203",
    "data-name": "Grupo 17203",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17202",
    "data-name": "Grupo 17202",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4498",
    "data-name": "Rect\\xE1ngulo 4498",
    width: 13.659,
    height: 12.322,
    fill: "url(#linear-gradient-18)"
  }))))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17211",
    "data-name": "Grupo 17211",
    transform: "translate(293.574 240.772)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17210",
    "data-name": "Grupo 17210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17209",
    "data-name": "Grupo 17209",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17208",
    "data-name": "Grupo 17208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17207",
    "data-name": "Grupo 17207",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4500",
    "data-name": "Rect\\xE1ngulo 4500",
    width: 12.989,
    height: 15.919,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-19)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17214",
    "data-name": "Grupo 17214",
    transform: "translate(249.025 246.51)",
    opacity: 0.1,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17213",
    "data-name": "Grupo 17213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17212",
    "data-name": "Grupo 17212",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12612",
    "data-name": "Trazado 12612",
    d: "M180.034,229.7l-15.323,1.649s-16.389-24.866-15.123-49.183c.833-2.382,1.682-4.663,2.548-6.879a195.7,195.7,0,0,1,11.326-24.233,27.3,27.3,0,0,1,3.9-3.048L183.2,171.625s1.016,38.49-3.164,58.077",
    transform: "translate(-149.518 -148.008)"
  }))))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12613",
    "data-name": "Trazado 12613",
    d: "M162.733,153.594l-1.069,60.22,10.291,53.495",
    transform: "translate(107.59 102.22)",
    fill: "none",
    stroke: "#ff88ad",
    strokeWidth: 12
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12614",
    "data-name": "Trazado 12614",
    d: "M168.652,145.7c8.566,3.734,11.159,17.6,11.159,17.6s-4.347,53.123-4.129,55.318.6,6.369.6,6.369L157.89,228.5s-1.537-9.883-2.415-30.089-.067-37.043,4.172-44.484,9.005-8.226,9.005-8.226",
    transform: "translate(103.26 96.967)",
    fill: "#ff88ad"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17217",
    "data-name": "Grupo 17217",
    transform: "translate(258.418 242.668)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17216",
    "data-name": "Grupo 17216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17215",
    "data-name": "Grupo 17215",
    clipPath: "url(#clip-path-65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12615",
    "data-name": "Trazado 12615",
    d: "M168.652,145.7c8.566,3.734,11.159,17.6,11.159,17.6s-4.347,53.123-4.129,55.318.6,6.369.6,6.369L157.89,228.5s-1.537-9.883-2.415-30.089-.067-37.043,4.172-44.484,9.005-8.226,9.005-8.226",
    transform: "translate(-155.158 -145.701)",
    fill: "#ff88ad"
  }))))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12616",
    "data-name": "Trazado 12616",
    d: "M155.158,195.061l22.5-3.734-1.372,5.711-18.614,3.836Z",
    transform: "translate(103.26 127.331)",
    fill: "#ff88ad"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17220",
    "data-name": "Grupo 17220",
    transform: "translate(258.418 318.659)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17219",
    "data-name": "Grupo 17219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17218",
    "data-name": "Grupo 17218",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12617",
    "data-name": "Trazado 12617",
    d: "M155.158,195.061l22.5-3.734-1.372,5.711-18.614,3.836Z",
    transform: "translate(-155.158 -191.327)",
    fill: "#ff88ad"
  }))))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12618",
    "data-name": "Trazado 12618",
    d: "M259.817,246.122l-3.641,52.9a3.311,3.311,0,0,1-3.583,2.955L184.167,298.2a3.24,3.24,0,0,1-3.15-3.346l3.639-52.9a3.312,3.312,0,0,1,3.584-2.955l68.426,3.767a3.215,3.215,0,0,1,3.149,3.346",
    transform: "translate(120.466 159.06)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17223",
    "data-name": "Grupo 17223",
    transform: "translate(301.477 398.062)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17222",
    "data-name": "Grupo 17222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17221",
    "data-name": "Grupo 17221",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12619",
    "data-name": "Trazado 12619",
    d: "M192.763,242.434l-3.641,52.9a3.325,3.325,0,0,1-3.583,2.955l-1.372-.08a3.242,3.242,0,0,1-3.15-3.346l3.641-52.9a3.311,3.311,0,0,1,3.583-2.955l1.372.08a3.229,3.229,0,0,1,3.15,3.346",
    transform: "translate(-181.011 -239.002)"
  }))))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12620",
    "data-name": "Trazado 12620",
    d: "M207.007,272.885l30.767-5.521s15.579,30.008,24.716,38.147l-34.158,12.618s-16.187-19.415-21.325-45.244",
    transform: "translate(137.767 177.935)",
    fill: "#ff88ad"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17226",
    "data-name": "Grupo 17226",
    transform: "translate(344.774 445.299)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17225",
    "data-name": "Grupo 17225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17224",
    "data-name": "Grupo 17224",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12621",
    "data-name": "Trazado 12621",
    d: "M207.007,272.885l30.767-5.521s15.579,30.008,24.716,38.147l-34.158,12.618s-16.187-19.415-21.325-45.244",
    transform: "translate(-207.007 -267.364)",
    fill: "#ff88ad"
  }))))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12622",
    "data-name": "Trazado 12622",
    d: "M206.529,256.76c5.766,3.459,22.9,30.967,22.9,30.967l35.91-19.868s-18.284-17.193-24.05-19.335-34.756,8.236-34.756,8.236",
    transform: "translate(137.449 165.204)",
    fill: "#ff5a96"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17229",
    "data-name": "Grupo 17229",
    transform: "translate(343.485 413.436)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17228",
    "data-name": "Grupo 17228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17227",
    "data-name": "Grupo 17227",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12623",
    "data-name": "Trazado 12623",
    d: "M206.233,256.76c5.863,3.459,23.281,30.967,23.281,30.967l36.513-19.868s-18.591-17.193-24.453-19.335-35.341,8.236-35.341,8.236",
    transform: "translate(-206.233 -248.233)",
    fill: "#ff5a96"
  }))))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12624",
    "data-name": "Trazado 12624",
    d: "M193.225,248.37s6.747,15.619,8.246,29.973l47.237-8.329s-7-18.482-10-21.643-45.485,0-45.485,0",
    transform: "translate(128.595 164.36)",
    fill: "#ff88ad"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17232",
    "data-name": "Grupo 17232",
    transform: "translate(321.82 411.326)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17231",
    "data-name": "Grupo 17231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17230",
    "data-name": "Grupo 17230",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12625",
    "data-name": "Trazado 12625",
    d: "M193.225,248.37s6.747,15.619,8.246,29.973l47.237-8.329s-7-18.482-10-21.643-45.485,0-45.485,0",
    transform: "translate(-193.225 -246.966)",
    fill: "#ff88ad"
  }))))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12626",
    "data-name": "Trazado 12626",
    d: "M196.2,246.62s4.98-16.385,12.7-15.221,18.264,8.193,20.241,16.978",
    transform: "translate(130.577 153.96)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 1.221
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12627",
    "data-name": "Trazado 12627",
    d: "M187.391,239.165a4.373,4.373,0,0,1,3.741,3.261l4.577,23.977a3.486,3.486,0,0,0,3.136,2.6l61.661,3.383a1.919,1.919,0,0,0,2.2-2.287l-4.592-24.055A4.353,4.353,0,0,0,254.2,242.8l-68.4-3.774Z",
    transform: "translate(123.651 159.074)",
    fill: "#263238"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17235",
    "data-name": "Grupo 17235",
    transform: "translate(309.448 398.097)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17234",
    "data-name": "Grupo 17234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17233",
    "data-name": "Grupo 17233",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12628",
    "data-name": "Trazado 12628",
    d: "M187.391,239.165a4.373,4.373,0,0,1,3.741,3.261l4.577,23.977a3.486,3.486,0,0,0,3.136,2.6l61.661,3.383a1.919,1.919,0,0,0,2.2-2.287l-4.592-24.055A4.353,4.353,0,0,0,254.2,242.8l-68.4-3.774Z",
    transform: "translate(-185.797 -239.023)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17238",
    "data-name": "Grupo 17238",
    transform: "translate(352.262 425.282)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17237",
    "data-name": "Grupo 17237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17236",
    "data-name": "Grupo 17236",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12629",
    "data-name": "Trazado 12629",
    d: "M221.167,271.179l-4.787-.278a1.3,1.3,0,0,1-1.091-.929L211.5,255.345l6.514.378L221.8,270.35a.609.609,0,0,1-.636.829",
    transform: "translate(-211.504 -255.345)"
  }))))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12630",
    "data-name": "Trazado 12630",
    d: "M219.352,264.443a.733.733,0,0,1-.087,0l-4.582-.266a2.056,2.056,0,0,1-1.759-1.489l-.755-2.906a1.273,1.273,0,0,1,.21-1.143,1.142,1.142,0,0,1,1-.406l4.58.266a2.058,2.058,0,0,1,1.762,1.489l.753,2.906a1.274,1.274,0,0,1-.208,1.141,1.158,1.158,0,0,1-.919.411m-.043-.761a.464.464,0,0,0,.375-.132.539.539,0,0,0,.06-.47l-.753-2.906a1.3,1.3,0,0,0-1.069-.921l-4.58-.266a.447.447,0,0,0-.373.13.533.533,0,0,0-.06.471l.753,2.906a1.294,1.294,0,0,0,1.068.921Z",
    transform: "translate(141.17 171.851)",
    fill: "#263238"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17241",
    "data-name": "Grupo 17241",
    transform: "translate(353.291 430.073)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17240",
    "data-name": "Grupo 17240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17239",
    "data-name": "Grupo 17239",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12631",
    "data-name": "Trazado 12631",
    d: "M219.352,264.443a.733.733,0,0,1-.087,0l-4.582-.266a2.056,2.056,0,0,1-1.759-1.489l-.755-2.906a1.273,1.273,0,0,1,.21-1.143,1.142,1.142,0,0,1,1-.406l4.58.266a2.058,2.058,0,0,1,1.762,1.489l.753,2.906a1.274,1.274,0,0,1-.208,1.141,1.158,1.158,0,0,1-.919.411m-.043-.761a.464.464,0,0,0,.375-.132.539.539,0,0,0,.06-.47l-.753-2.906a1.3,1.3,0,0,0-1.069-.921l-4.58-.266a.447.447,0,0,0-.373.13.533.533,0,0,0-.06.471l.753,2.906a1.294,1.294,0,0,0,1.068.921Z",
    transform: "translate(-212.121 -258.222)",
    fill: "#fff"
  }))))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17247",
    "data-name": "Grupo 17247",
    transform: "translate(518.791 262.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17246",
    "data-name": "Grupo 17246",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12632",
    "data-name": "Trazado 12632",
    d: "M83.991,62.946a31.835,31.835,0,0,1-1.539,5.135c-2.787,5.71-7.486,8.594-13.83,8.62-11.826.047-23.652.014-35.478.014q-8.89,0-17.78,0A14.359,14.359,0,0,1,3.532,71.245C-.247,66.469-1.129,61.1,1.545,55.6c2.236-4.6,5-8.953,7.556-13.4Q18.97,25.073,28.864,7.961A15.086,15.086,0,0,1,39.479.241c5.4-1.055,11.77,1.41,14.665,6.078,3.1,5.006,5.988,10.15,8.939,15.25,6.068,10.484,12.1,20.989,18.188,31.462a20.04,20.04,0,0,1,2.72,7.458Zm-42.1,7q13.27,0,26.539,0A8.519,8.519,0,0,0,74.2,68.037a8.192,8.192,0,0,0,1.712-10.725q-10.343-17.933-20.7-35.856C53.071,17.749,51,13.995,48.729,10.369a7.5,7.5,0,0,0-7.515-3.524,8,8,0,0,0-6.419,4.365Q24.336,29.36,13.841,47.488c-2.059,3.566-4.192,7.094-6.119,10.731A7.585,7.585,0,0,0,8.253,66.3a8.063,8.063,0,0,0,7.264,3.652q13.188-.01,26.375,0",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12633",
    "data-name": "Trazado 12633",
    d: "M237.858,148.775c-.33,5.672-.662,11.39-.994,17.109a19.651,19.651,0,0,1-.159,2.442,3.142,3.142,0,0,1-3.119,2.509,3.011,3.011,0,0,1-3.1-2.591c-.249-2.192-.329-4.4-.466-6.607-.27-4.328-.509-8.658-.8-12.985-.212-3.135,2.059-5.554,4.945-5.2a4.248,4.248,0,0,1,3.694,3.886c.035.461.005.926.005,1.435",
    transform: "translate(-191.565 -119.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12634",
    "data-name": "Trazado 12634",
    d: "M229.9,332.693a4.323,4.323,0,0,1,4.357-4.264,4.295,4.295,0,0,1-.065,8.586,4.3,4.3,0,0,1-4.293-4.322",
    transform: "translate(-192.15 -274.499)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.5a8eac5b37dc42e3e9b9760a705e826a.svg";
export { ForwardRef as ReactComponent };